import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ref as refApi, reservations as resApi, clientGroups as cgApi, marketerGroups as mgApi, audit as auditApi, addWithDupGuard } from "../services/api";
import PhoneInput from "../components/PhoneInput"; // v3.3.749 — إدخال جوال موحّد
import { useAuth } from "../context/AuthContext";
import toast from "react-hot-toast";
import { FiPlus, FiTrash2, FiPhone, FiUser, FiFileText, FiUpload, FiDownload, FiEdit2, FiCheck, FiX, FiCheckSquare, FiSquare, FiSettings } from "react-icons/fi";
import GenericHeaderMenu from "../components/GenericHeaderMenu"; // v3.3.999 — هيدر الحجوزات القياسي
import ClientQualityPanel from "../components/ClientQualityPanel"; // v3.4.140 — جودة بيانات العملاء

// ── InterestsTags: multi-select tags for marketer interests ───────────────────
function InterestsTags({ interests = [], onChange }) {
  const [input, setInput] = useState("");
  const tags = Array.isArray(interests) ? interests : [];
  const add = (tag) => {
    const t = tag.trim();
    if (t && !tags.includes(t)) onChange([...tags, t]);
    setInput("");
  };
  const remove = (t) => onChange(tags.filter(x => x !== t));
  return (
    <div style={{ border:"1px solid #e2e8f0", borderRadius:7, padding:"6px 8px", minHeight:38, display:"flex", flexWrap:"wrap", gap:5, alignItems:"center" }}>
      {tags.map((t,i) => (
        <span key={i} style={{ background:"#e0e7ff", color:"#3730a3", borderRadius:10, padding:"2px 8px", fontSize:11, fontWeight:600, display:"flex", alignItems:"center", gap:4 }}>
          {t}
          <button onClick={() => remove(t)} style={{ background:"none", border:"none", cursor:"pointer", color:"#6366f1", fontSize:12, padding:0, lineHeight:1 }}>×</button>
        </span>
      ))}
      <input
        value={input}
        onChange={e => setInput(e.target.value)}
        onKeyDown={e => { if (e.key === "Enter" || e.key === ",") { e.preventDefault(); add(input); } }}
        onBlur={() => { if (input.trim()) add(input); }}
        placeholder="أضف tag ثم Enter..."
        style={{ border:"none", outline:"none", fontFamily:"inherit", fontSize:12, color:"#374151", minWidth:120, flex:1, background:"transparent" }}
      />
    </div>
  );
}


const btnStyle = (bg, color, border) => ({
  padding: "7px 14px", background: bg, color, border, borderRadius: 7,
  fontFamily: "inherit", fontSize: 12, cursor: "pointer", display:"flex", alignItems:"center", gap:5,
});

const tdS = { padding: "8px 12px", fontSize: 13, borderBottom: "1px solid #f1f5f9", verticalAlign: "middle" };
const thS = { padding: "8px 12px", fontSize: 11, fontWeight: 600, color: "#64748b", background: "#f8fafc", borderBottom: "2px solid #e2e8f0", textAlign: "right", whiteSpace: "nowrap" };

const labelS = { display: "block", fontSize: 11, fontWeight: 600, color: "#64748b", marginBottom: 4 };
const inputS = { width: "100%", padding: "8px 10px", border: "1px solid #e2e8f0", borderRadius: 6, fontFamily: "inherit", fontSize: 13, outline: "none", boxSizing: "border-box" };

const inlineInput = {
  padding: "5px 8px", border: "1px solid #93c5fd", borderRadius: 5,
  fontFamily: "inherit", fontSize: 13, width: "100%", outline: "none", boxSizing: "border-box",
};

export default function RefListPage({ type }) {
  const { user } = useAuth();
  const isAdmin = user?.role === "admin" && !user?.impersonating;
  const modPermsKey = { client: "clients", developer: "developers", marketer: "marketers" }[type];
  const mp = user?.module_perms?.[modPermsKey] || {};
  const canAdd = isAdmin || mp.can_add;
  const canExport = isAdmin || mp.can_export;
  const canImport = isAdmin || mp.can_import;
  const canEdit = isAdmin || mp.full_edit || (mp.edit_days && mp.edit_days !== 0);
  
  // Check if user can view reservations (for linked reservations display)
  const resPerms = user?.module_perms?.reservations || {};
  const canViewReservations = isAdmin || resPerms.can_view_reservations;

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  // v3.3.752 — سجل التعديلات على القائمة (من سجل التدقيق، حسب نوع الكيان)
  const canViewAudit = (user?.role === "admin" && !user?.impersonating) || user?.can_view_audit;
  const [showAuditLog, setShowAuditLog] = useState(false);
  const [showQuality, setShowQuality] = useState(false); // v3.4.140 — لوحة جودة بيانات العملاء
  const [auditRows, setAuditRows] = useState(null);
  useEffect(() => {
    if (!showAuditLog) return;
    setAuditRows(null);
    auditApi.list({ module: modPermsKey, limit: 100 })
      .then(r => setAuditRows(r.data.items || []))
      .catch(() => setAuditRows([]));
  }, [showAuditLog, modPermsKey]);
  const [entityPanel, setEntityPanel] = useState(null);
  // v3.4.732 — فتح بطاقة كيان مباشرة بالرابط ?open=ID (زر «تعديل في المصدر» في مستندات إعادة البيع)
  const openedByLink = useRef(false);
  const [allOptions, setAllOptions] = useState({});
  const [form, setForm] = useState({ name: "", client_number: "", client_type: "", classification: "", phone: "", company: "", representative_name: "", representative_phone: "", interests: [], notes: "" });
  const [search, setSearch] = useState("");
  const [filterField, setFilterField] = useState("all");
  const [colFilters, setColFilters] = useState({}); // v3.3.999 — فلاتر قيم لكل عمود (نمط إكسل المتسلسل)
  // Multi-select quick filters for clients
  const [qfCompany, setQfCompany] = useState(""); // "", "yes", "no"
  const [qfCategories, setQfCategories] = useState([]); // multi-select نوع العميل
  const [qfStages, setQfStages] = useState([]); // multi-select تصنيف العميل
  const [qfSources, setQfSources] = useState([]); // multi-select مصدر العميل
  const [qfInterests, setQfInterests] = useState([]); // multi-select الاهتمامات
  // Column visibility — per type
  const clientColDefs = [
    { key: "client_number", label: "رقم الهوية" },
    { key: "phone", label: "الهاتف" },
    { key: "is_company_client", label: "عميل الشركة" },
    { key: "client_category", label: "نوع العميل" },
    { key: "client_stage", label: "تصنيف العميل" },
    { key: "client_type", label: "مصدر العميل" },
    { key: "iban", label: "IBAN" },
    { key: "visit_count", label: "الزيارات" },
    { key: "notes", label: "ملاحظات" },
  ];
  const marketerColDefs = [
    { key: "phone", label: "الهاتف" },
    { key: "office", label: "شركة المسوق" },
    { key: "interests", label: "اهتمامات" },
    // v3.3.486 — Reservations and sales counts for this marketer
    { key: "reservations_count", label: "الحجوزات" },
    { key: "sales_count", label: "المبيعات" },
    { key: "notes", label: "ملاحظات" },
  ];
  const developerColDefs = [
    { key: "representative_name", label: "ممثل المطور" },
    { key: "representative_phone", label: "رقم الممثل" },
    { key: "is_company_project", label: "مشروع الشركة" },
    { key: "notes", label: "ملاحظات" },
  ];
  const activeColDefs = type === "client" ? clientColDefs : type === "marketer" ? marketerColDefs : developerColDefs;
  const storageKey = type === "client" ? "clientHiddenCols" : type === "marketer" ? "marketerHiddenCols" : "developerHiddenCols";
  const [hiddenCols, setHiddenCols] = useState(() => {
    try { const s = localStorage.getItem(storageKey); return s ? JSON.parse(s) : []; } catch { return []; }
  });
  useEffect(() => {
    try { const s = localStorage.getItem(storageKey); setHiddenCols(s ? JSON.parse(s) : []); } catch { setHiddenCols([]); }
  }, [type, storageKey]);
  const [showColMenu, setShowColMenu] = useState(false);
  const toggleCol = (key) => {
    setHiddenCols(prev => {
      const next = prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key];
      try { localStorage.setItem(storageKey, JSON.stringify(next)); } catch {}
      return next;
    });
  };
  const isColVisible = (key) => !hiddenCols.includes(key);
  // ── Multi-select quick filters for marketers ──
  const [qfMktInterests, setQfMktInterests] = useState([]);
  // ── Multi-select quick filters for developers ──
  const [qfDevCompanyProject, setQfDevCompanyProject] = useState("");
  // Reset filters when type changes
  useEffect(() => { setQfMktInterests([]); setQfDevCompanyProject(""); setQfCompany(""); setQfCategories([]); setQfStages([]); setQfSources([]); setQfInterests([]); setSearch(""); setColFilters({}); }, [type]); // v3.3.999 — تصفير فلاتر الأعمدة أيضًا
  // Multi-select toggle helper
  const toggleMulti = (setter, val) => setter(prev => prev.includes(val) ? prev.filter(v => v !== val) : [...prev, val]);
  const [selected, setSelected] = useState(new Set());
  const [editingId, setEditingId] = useState(null);
  const [editForm, setEditForm] = useState({ name: "", client_number: "", client_type: "", classification: "", phone: "", notes: "" });
  const fileRef = useRef();

  const config = {
    // v3.3.741 — addWithDupGuard: تحذير عند إضافة عميل/مسوق بنفس الاسم أو الجوال
    client:    { title: "إدارة العملاء",    icon: "👥",  fetch: refApi.getClients,    add: (d) => addWithDupGuard(refApi.addClient, d),    del: refApi.deleteClient,    update: refApi.updateClient,    bulk: refApi.bulkAddClients,    hasPhone: true  },
    developer: { title: "إدارة المطورين",  icon: "🏗️",  fetch: refApi.getDevelopers, add: refApi.addDeveloper, del: refApi.deleteDeveloper, update: refApi.updateDeveloper, bulk: refApi.bulkAddDevelopers, hasPhone: false },
    marketer:  { title: "إدارة المسوقين",  icon: "📢",  fetch: refApi.getMarketers,  add: (d) => addWithDupGuard(refApi.addMarketer, d),  del: refApi.deleteMarketer,  update: refApi.updateMarketer,  bulk: refApi.bulkAddMarketers,  hasPhone: true  },
  }[type];

  const fetchItems = () => {
    config.fetch().then(r => setItems(r.data.items)).catch(() => toast.error("فشل")).finally(() => setLoading(false));
  };
  useEffect(() => { fetchItems(); setSelected(new Set()); }, [type]);
  useEffect(() => {
    if (openedByLink.current || !items.length) return;
    try { const id = new URLSearchParams(window.location.search).get("open"); if (!id) return; openedByLink.current = true; const it = items.find((x) => String(x.id) === String(id)); if (it) { setEntityPanel({ ...it }); setSearch(it.name || ""); } } catch { /* */ }
  }, [items]); // v3.4.732
  useEffect(() => {
    refApi.getAllOptions().then(r => setAllOptions(r.data.options || {})).catch(() => {});
  }, []);

  const handleAdd = async () => {
    if (!form.name.trim()) return toast.error("الاسم مطلوب");
    try {
      await config.add(form);
      toast.success("تمت الإضافة");
      setForm({ name: "", client_number: "", client_type: "", classification: "", phone: "", company: "", representative_name: "", representative_phone: "", interests: [], notes: "" });
      setShowForm(false);
      fetchItems();
    } catch (err) { toast.error(err.response?.data?.error || "فشل"); }
  };

  const handleDelete = async (item) => {
    if (!window.confirm(`حذف "${item.name}"؟`)) return;
    try { await config.del(item.id); toast.success("تم الحذف"); fetchItems(); }
    catch (err) { toast.error("فشل"); }
  };

  const [isDeleting, setIsDeleting] = useState(false);
  const handleDeleteSelected = async () => {
    if (selected.size === 0) return;
    if (!window.confirm(`حذف ${selected.size} عنصر؟`)) return;
    
    setIsDeleting(true);
    let ok = 0, fail = 0;
    const ids = Array.from(selected);
    
    for (let i = 0; i < ids.length; i++) {
      try { 
        await config.del(ids[i]); 
        ok++; 
      } catch (e) { 
        fail++;
        // If rate limited, wait longer before retrying
        if (e.response?.status === 429 || e.message?.includes('Too many')) {
          await new Promise(r => setTimeout(r, 2000));
        }
      }
      // Delay after EVERY deletion to avoid rate limiting
      if (i < ids.length - 1) {
        await new Promise(r => setTimeout(r, 300));
      }
    }
    
    toast.success(`تم حذف ${ok}${fail > 0 ? ` (فشل ${fail})` : ""}`);
    setSelected(new Set());
    setIsDeleting(false);
    fetchItems();
  };

  const startEdit = (item) => {
    setEditingId(item.id);
    setEditForm({
      name: item.name || "",
      client_number: item.client_number || "",
      client_type: item.client_type || "",
      classification: item.classification || "",
      phone: item.phone || "",
      notes: item.notes || ""
    });
  };

  const handleUpdate = async (id) => {
    if (!editForm.name.trim()) return toast.error("الاسم مطلوب");
    try {
      if (config.update) {
        await config.update(id, type === "client"
          ? { name: editForm.name, client_number: editForm.client_number, client_type: editForm.client_type, classification: editForm.classification, phone: editForm.phone, notes: editForm.notes }
          : config.hasPhone
            ? { name: editForm.name, phone: editForm.phone, notes: editForm.notes }
            : { name: editForm.name, notes: editForm.notes }
        );
        toast.success("تم التحديث");
      } else {
        toast.error("التعديل غير مدعوم");
      }
      setEditingId(null);
      fetchItems();
    } catch (err) { toast.error(err.response?.data?.error || "فشل التحديث"); }
  };

  // v3.3.999 — نمط إكسل المتسلسل (كما في التحصيلات v3.3.994): applyFilters(exceptKey) يشغّل كل الفلاتر
  // مع استثناء فلتر العمود المطلوب — قوائم القيم تعرض المتبقي الظاهر فقط
  const getColVal = (i, k) =>
    k === "is_company_client" ? (i.is_company_client ? "نعم" : "لا")
    : k === "is_company_project" ? (i.is_company_project ? "نعم" : "لا")
    : (i[k] ?? "");
  const applyFilters = (arr, exceptKey) => arr.filter(i => {
    if (!Object.entries(colFilters).every(([k, vals]) => k === exceptKey || !vals?.length || vals.includes(String(getColVal(i, k))))) return false;
    const q = search.toLowerCase();
    if (q) {
      if (filterField === "name" && !i.name?.toLowerCase().includes(q)) return false;
      else if (filterField === "phone" && !i.phone?.includes(q)) return false;
      else if (filterField === "notes" && !i.notes?.toLowerCase().includes(q)) return false;
      else if (filterField === "all" && !(i.name?.toLowerCase().includes(q) || i.phone?.includes(q) || i.notes?.toLowerCase().includes(q) || i.client_number?.includes(q) || i.iban?.includes(q))) return false;
    }
    if (type === "client") {
      if (qfCompany === "yes" && !i.is_company_client) return false;
      if (qfCompany === "no" && i.is_company_client) return false;
      if (qfCategories.length > 0 && !qfCategories.includes(i.client_category)) return false;
      if (qfStages.length > 0 && !qfStages.includes(i.client_stage)) return false;
      if (qfSources.length > 0 && !qfSources.includes(i.client_type)) return false;
      if (qfInterests.length > 0) {
        const int = i.interests ? (typeof i.interests === "string" ? JSON.parse(i.interests) : i.interests) : {};
        const allVals = [...(int.districts||[]), ...(int.project_types||[]), ...(int.unit_types||[]), ...(int.projects||[])];
        if (!qfInterests.some(qi => allVals.includes(qi))) return false;
      }
    }
    if (type === "marketer") {
      if (qfMktInterests.length > 0) {
        let tags = [];
        try { tags = i.interests ? (typeof i.interests === "string" ? JSON.parse(i.interests) : i.interests) : []; } catch {}
        if (!Array.isArray(tags)) tags = [];
        if (!qfMktInterests.some(qi => tags.includes(qi))) return false;
      }
    }
    if (type === "developer") {
      if (qfDevCompanyProject === "yes" && !i.is_company_project) return false;
      if (qfDevCompanyProject === "no" && i.is_company_project) return false;
    }
    return true;
  });
  const filteredItems = applyFilters(items, null);
  const distinctOf = (k) => [...new Set(applyFilters(items, k).map(i => String(getColVal(i, k))).filter(Boolean))].sort((a, b) => a.localeCompare(b, "ar"));

  // v3.3.670 — فرز الأعمدة (v3.3.999: عبر قائمة الهيدر القياسية)
  const [sortKey, setSortKey] = useState(null);
  const [sortDir, setSortDir] = useState("asc");
  const sortedItems = sortKey
    ? [...filteredItems].sort((a, b) => {
        const NUM = ["id", "visit_count", "reservations_count", "sales_count"];
        const BOOL = ["is_company_client", "is_company_project"];
        let va = a[sortKey], vb = b[sortKey];
        if (NUM.includes(sortKey)) { va = Number(va) || 0; vb = Number(vb) || 0; return sortDir === "asc" ? va - vb : vb - va; }
        if (BOOL.includes(sortKey)) { va = va ? 1 : 0; vb = vb ? 1 : 0; return sortDir === "asc" ? va - vb : vb - va; }
        va = String(va || ""); vb = String(vb || "");
        return sortDir === "asc" ? va.localeCompare(vb, "ar") : vb.localeCompare(va, "ar");
      })
    : filteredItems;
  // v3.3.999 — رأس عمود بنمط جدول الحجوزات: قائمة فرز + فلتر قيم متسلسل (filter prop)
  const SortTh = ({ label, k, style, filter = false }) => (
    k ? (
      <GenericHeaderMenu label={label} colKey={k} sortBy={sortKey} sortDir={sortDir}
        onSort={(key, dir) => { setSortKey(key); setSortDir(dir); }}
        values={filter ? distinctOf(k) : null}
        activeFilter={colFilters[k] || []}
        onFilter={(key, vals) => setColFilters(f => ({ ...f, [key]: vals }))}
        align="right" color="#64748b" />
    ) : (
      <th style={{ ...thS, ...style, whiteSpace: "nowrap" }}>{label}</th>
    )
  );

  const allSelected  = filteredItems.length > 0 && filteredItems.every(i => selected.has(i.id));
  const someSelected = filteredItems.some(i => selected.has(i.id)) && !allSelected;

  const toggleSelectAll = () => {
    if (allSelected) {
      setSelected(s => { const n = new Set(s); filteredItems.forEach(i => n.delete(i.id)); return n; });
    } else {
      setSelected(s => { const n = new Set(s); filteredItems.forEach(i => n.add(i.id)); return n; });
    }
  };
  const toggleOne = (id) => setSelected(s => { const n = new Set(s); n.has(id) ? n.delete(id) : n.add(id); return n; });

  const handleExport = () => {
    const BOM = "\uFEFF";
    let header, rows;
    
    if (type === "client") {
      header = "الاسم,رقم العميل,نوع العميل,التصنيف,الهاتف,ملاحظات,تاريخ الإضافة\n";
      rows = items.map(i => [
        i.name || "",
        i.client_number || "",
        i.client_type || "",
        i.classification || "",
        i.phone || "",
        (i.notes || "").replace(/"/g, '""'),
        i.created_at ? new Date(i.created_at).toLocaleDateString('ar-SA') : ""
      ].map(v => `"${v}"`).join(",")).join("\n");
    } else if (type === "developer") {
      header = "الاسم,ممثل المطور,رقم الممثل,ملاحظات,تاريخ الإضافة\n";
      rows = items.map(i => [
        i.name || "",
        i.representative_name || "",
        i.representative_phone || "",
        (i.notes || "").replace(/"/g, '""'),
        i.created_at ? new Date(i.created_at).toLocaleDateString('ar-SA') : ""
      ].map(v => `"${v}"`).join(",")).join("\n");
    } else if (type === "marketer") {
      header = "الاسم,الهاتف,المكتب/الشركة,الاهتمامات,ملاحظات,تاريخ الإضافة\n";
      rows = items.map(i => [
        i.name || "",
        i.phone || "",
        i.office || "",
        Array.isArray(i.interests) ? i.interests.join(" | ") : (i.interests || ""),
        (i.notes || "").replace(/"/g, '""'),
        i.created_at ? new Date(i.created_at).toLocaleDateString('ar-SA') : ""
      ].map(v => `"${v}"`).join(",")).join("\n");
    }
    
    const blob = new Blob([BOM + header + rows], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = `${type}_export.csv`; a.click();
    URL.revokeObjectURL(url);
    toast.success(`تم تصدير ${items.length} عنصر`);
  };

  const handleUpload = (e) => {
    const file = e.target.files[0]; if (!file) return;
    const reader = new FileReader();
    reader.onload = async (evt) => {
      const text = evt.target.result.replace(/^\uFEFF/, "");
      const parseCSVLine = (line) => {
        const fields = []; let field = ""; let inQ = false;
        for (let i = 0; i < line.length; i++) {
          const ch = line[i], nx = line[i+1];
          if (inQ) {
            if (ch === '"' && nx === '"') { field += '"'; i++; }
            else if (ch === '"') { inQ = false; }
            else { field += ch; }
          } else {
            if (ch === '"') { inQ = true; }
            else if (ch === ',') { fields.push(field.trim()); field = ""; }
            else { field += ch; }
          }
        }
        fields.push(field.trim());
        return fields;
      };
      const lines = text.split("\n").filter(l => l.trim());
      const startIdx = lines[0].includes("الاسم") || lines[0].toLowerCase().includes("name") ? 1 : 0;
      const rows = [];
      for (let i = startIdx; i < lines.length; i++) {
        const parts = parseCSVLine(lines[i]);
        const name = parts[0]; if (!name) continue;
        
        // Parse based on entity type - matching CSV export column order
        if (type === "clients") {
          // CSV columns: الاسم، رقم العميل، نوع العميل، التصنيف، الهاتف، ملاحظات، تاريخ الإضافة
          rows.push({ 
            name, 
            client_number: parts[1] || "", 
            client_type: parts[2] || "", 
            classification: parts[3] || "",
            phone: parts[4] || "", 
            notes: parts[5] || "" 
          });
        } else if (type === "developers") {
          // CSV columns: الاسم، ممثل المطور، رقم الممثل، ملاحظات، تاريخ الإضافة
          rows.push({ 
            name, 
            representative_name: parts[1] || "", 
            representative_phone: parts[2] || "",
            notes: parts[3] || "" 
          });
        } else if (type === "marketers") {
          // CSV columns: الاسم، الهاتف، المكتب/الشركة، الاهتمامات، ملاحظات، تاريخ الإضافة
          rows.push({ 
            name, 
            phone: parts[1] || "", 
            office: parts[2] || "",
            interests: parts[3] || "",
            notes: parts[4] || "" 
          });
        } else {
          rows.push({ name, phone: parts[1] || "", notes: parts[2] || "" });
        }
      }
      try {
        if (config.bulk && rows.length > 10) {
          const r = await config.bulk(rows);
          toast.success(`تمت إضافة ${r.data.count} عنصر`);
        } else {
          let added = 0, errors = 0;
          for (const row of rows) {
            try { await config.add(row); added++; } catch { errors++; }
          }
          toast.success("تمت إضافة " + added + " عنصر" + (errors > 0 ? " (" + errors + " خطأ)" : ""));
        }
      } catch { toast.error("فشل الرفع"); }
      fetchItems();
    };
    reader.readAsText(file, "UTF-8");
    e.target.value = "";
  };

  if (loading) return <div style={{ padding: 40, color: "#64748b" }}>جاري التحميل...</div>;

  return (
    <>
    <div dir="rtl" style={{ padding: 20 }}>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
        <div>
          <h1 style={{ fontSize: 20, fontWeight: 700 }}>{config.icon} {config.title}</h1>
          <p style={{ fontSize: 12, color: "#64748b", marginTop: 2 }}>
            {items.length} مسجل
            {selected.size > 0 && <span style={{ color: "#2563eb", marginRight: 8, fontWeight: 600 }}>— {selected.size} محدد</span>}
          </p>
        </div>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          {selected.size > 0 && canEdit && (
            <button onClick={handleDeleteSelected} disabled={isDeleting}
              style={{...btnStyle("#fef2f2","#ef4444","1px solid #fca5a5"), opacity: isDeleting ? 0.6 : 1, cursor: isDeleting ? "wait" : "pointer"}}>
              <FiTrash2 size={14} /> {isDeleting ? "جاري الحذف..." : `حذف المحددين (${selected.size})`}
            </button>
          )}
          {canExport && <button onClick={handleExport}          style={btnStyle("#f8fafc","#475569","1px solid #e2e8f0")}><FiDownload size={14} /> تصدير CSV</button>}
          {canImport && <>
            <button onClick={() => fileRef.current.click()} style={btnStyle("#f0fdf4","#166534","1px solid #bbf7d0")}><FiUpload size={14} /> رفع CSV</button>
            <input ref={fileRef} type="file" accept=".csv,.txt" onChange={handleUpload} style={{ display: "none" }} />
          </>}
          {/* v3.4.140 — جودة بيانات العملاء */}
          {type === "client" && <button onClick={() => setShowQuality(true)} style={btnStyle("#f0fdfa","#0f766e","1px solid #99f6e4")}>
            🩺 جودة البيانات
          </button>}
          {/* v3.3.752 — سجل التعديلات على القائمة */}
          {canViewAudit && <button onClick={() => setShowAuditLog(true)} style={btnStyle("#fffbeb","#a16207","1px solid #fde047")}>
            🕘 سجل التعديلات
          </button>}
          {canAdd && <button onClick={() => setShowForm(!showForm)} style={btnStyle(showForm?"#f1f5f9":"#2563eb", showForm?"#64748b":"#fff", showForm?"1px solid #e2e8f0":"none")}>
            {showForm ? "إلغاء" : <><FiPlus /> إضافة</>}
          </button>}
        </div>
      </div>

      {/* Add Form — v3.3.752: بوب أب بدل الفورم المضمّن أعلى الصفحة */}
      {showForm && (
        <div onClick={() => setShowForm(false)}
          style={{ position:"fixed", inset:0, background:"rgba(15,23,42,0.45)", zIndex:9000,
            display:"flex", alignItems:"flex-start", justifyContent:"center", padding:"6vh 16px", overflowY:"auto" }}>
        <div dir="rtl" onClick={e => e.stopPropagation()}
          style={{ background:"#fff", border:"1px solid #e2e8f0", borderRadius:14, padding:20,
            width:"min(720px, 100%)", boxShadow:"0 20px 60px rgba(0,0,0,0.3)" }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:14, paddingBottom:10, borderBottom:"1px solid #f1f5f9" }}>
            <span style={{ fontSize:15, fontWeight:800, color:"#1e293b" }}>
              <FiPlus style={{ verticalAlign:"middle", marginLeft:4 }} />
              {type === "client" ? "إضافة عميل جديد" : type === "developer" ? "إضافة مطور جديد" : "إضافة مسوق جديد"}
            </span>
            <button onClick={() => setShowForm(false)}
              style={{ background:"#f1f5f9", border:"none", color:"#64748b", borderRadius:8, width:30, height:30, cursor:"pointer", fontSize:15 }}>✕</button>
          </div>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
            <div><label style={labelS}>{type === "client" ? "اسم العميل *" : type === "developer" ? "اسم المطور *" : "اسم المسوق *"}</label>
              <input value={form.name} onChange={e => setForm({...form,name:e.target.value})} placeholder="أدخل الاسم" style={inputS} autoFocus /></div>

            {type === "client" && <>
              {/* v3.3.749 — إدخال جوال موحّد */}
              <div><label style={labelS}>الهاتف</label>
                <PhoneInput value={form.phone||""} intl={form._phone_intl}
                  onChange={v => setForm({...form,phone:v})} onIntlChange={v => setForm({...form,_phone_intl:v})} />
              </div>
              <div><label style={labelS}>رقم هوية العميل</label><input value={form.client_number||""} onChange={e => setForm({...form,client_number:e.target.value})} placeholder="رقم الهوية" style={inputS} /></div>
              <div>
                <label style={labelS}>مصدر العميل</label>
                <select value={form.client_type||""} onChange={e => setForm({...form,client_type:e.target.value})} style={inputS}>
                  <option value="">— اختر —</option>
                  {(allOptions?.client_type||[]).map(o => <option key={o.id} value={o.label}>{o.label}</option>)}
                </select>
              </div>
              <div>
                <label style={labelS}>نوع العميل</label>
                <select value={form.client_category||""} onChange={e => setForm({...form,client_category:e.target.value})} style={inputS}>
                  <option value="">— اختر —</option>
                  {(allOptions?.client_category||[]).map(o => <option key={o.id} value={o.label}>{o.label}</option>)}
                </select>
              </div>
              <div>
                <label style={labelS}>تصنيف العميل</label>
                <select value={form.client_stage||""} onChange={e => setForm({...form,client_stage:e.target.value})} style={inputS}>
                  <option value="">— اختر —</option>
                  {(allOptions?.client_stage||[]).map(o => <option key={o.id} value={o.label}>{o.label}</option>)}
                </select>
              </div>
            </>}

            {type === "marketer" && <>
              {/* v3.3.749 — إدخال جوال موحّد */}
              <div><label style={labelS}>رقم المسوق</label>
                <PhoneInput value={form.phone||""} intl={form._phone_intl}
                  onChange={v => setForm({...form,phone:v})} onIntlChange={v => setForm({...form,_phone_intl:v})} />
              </div>
              <div><label style={labelS}>شركة المسوق</label><input value={form.company||""} onChange={e => setForm({...form,company:e.target.value})} placeholder="اسم الشركة أو المكتب" style={inputS} /></div>
              <div style={{ gridColumn:"1/-1" }}>
                <label style={labelS}>🏷 اهتمامات المسوق (Tags)</label>
                <InterestsTags interests={form.interests||[]} onChange={v => setForm({...form,interests:v})} />
              </div>
            </>}

            {type === "developer" && <>
              <div><label style={labelS}>ممثل المطور</label><input value={form.representative_name||""} onChange={e => setForm({...form,representative_name:e.target.value})} placeholder="اسم الممثل" style={inputS} /></div>
              <div><label style={labelS}>رقم ممثل المطور</label><input value={form.representative_phone||""} onChange={e => setForm({...form,representative_phone:e.target.value})} placeholder="رقم الهاتف" style={inputS} /></div>
            </>}

            <div style={{ gridColumn:"1/-1" }}>
              <label style={labelS}>ملاحظات</label>
              <textarea value={form.notes||""} onChange={e => setForm({...form,notes:e.target.value})} rows={2} placeholder="ملاحظات اختيارية..."
                style={{ ...inputS, resize:"vertical" }} />
            </div>
          </div>
          <div style={{ display:"flex", gap:8, marginTop:14 }}>
            <button onClick={handleAdd} style={{ flex:1, padding:"10px 24px", background:"#166534", color:"#fff", border:"none", borderRadius:7, fontFamily:"inherit", fontSize:13, fontWeight:700, cursor:"pointer" }}>
              <FiPlus style={{ verticalAlign:"middle", marginLeft:4 }} /> إضافة
            </button>
            <button onClick={() => setShowForm(false)} style={{ padding:"10px 20px", background:"#f1f5f9", color:"#64748b", border:"none", borderRadius:7, fontFamily:"inherit", fontSize:13, cursor:"pointer" }}>
              إلغاء
            </button>
          </div>
        </div>
        </div>
      )}

      {/* v3.4.140 — لوحة جودة بيانات العملاء */}
      {showQuality && <ClientQualityPanel onClose={() => setShowQuality(false)} onOpenClient={(id, name) => { setShowQuality(false); setSearch(name || String(id)); }} />}
      {/* v3.3.752 — بوب أب سجل التعديلات على القائمة (من سجل التدقيق) */}
      {showAuditLog && (
        <div onClick={() => setShowAuditLog(false)}
          style={{ position:"fixed", inset:0, background:"rgba(15,23,42,0.45)", zIndex:9000,
            display:"flex", alignItems:"flex-start", justifyContent:"center", padding:"6vh 16px", overflowY:"auto" }}>
        <div dir="rtl" onClick={e => e.stopPropagation()}
          style={{ background:"#fff", border:"1px solid #e2e8f0", borderRadius:14,
            width:"min(860px, 100%)", boxShadow:"0 20px 60px rgba(0,0,0,0.3)", overflow:"hidden" }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"14px 20px",
            background:"linear-gradient(135deg,#1e293b,#334155)" }}>
            <span style={{ fontSize:15, fontWeight:800, color:"#fff" }}>🕘 سجل التعديلات — {config.title}</span>
            <button onClick={() => setShowAuditLog(false)}
              style={{ background:"rgba(255,255,255,0.15)", border:"none", color:"#fff", borderRadius:8, width:30, height:30, cursor:"pointer", fontSize:15 }}>✕</button>
          </div>
          <div style={{ maxHeight:"70vh", overflowY:"auto" }}>
            {auditRows === null ? (
              <div style={{ padding:40, textAlign:"center", color:"#94a3b8", fontSize:13 }}>جاري تحميل السجل...</div>
            ) : auditRows.length === 0 ? (
              <div style={{ padding:40, textAlign:"center", color:"#94a3b8", fontSize:13 }}>لا توجد حركات مسجلة</div>
            ) : (
              <table style={{ width:"100%", borderCollapse:"collapse" }}>
                <thead>
                  <tr>
                    <th style={thS}>التاريخ</th>
                    <th style={thS}>المستخدم</th>
                    <th style={thS}>الإجراء</th>
                    <th style={thS}>السجل</th>
                    <th style={thS}>التغييرات</th>
                  </tr>
                </thead>
                <tbody>
                  {auditRows.map(row => {
                    const actMap = {
                      create: { l:"إضافة", bg:"#dcfce7", c:"#166534" }, update: { l:"تعديل", bg:"#dbeafe", c:"#1e40af" },
                      delete: { l:"حذف", bg:"#fee2e2", c:"#991b1b" }, import: { l:"استيراد", bg:"#f3e8ff", c:"#7c3aed" },
                      merge_duplicate: { l:"دمج تكرار", bg:"#fef3c7", c:"#92400e" }, restore: { l:"استعادة", bg:"#dcfce7", c:"#166534" },
                    };
                    const act = actMap[row.action] || { l: row.action, bg:"#f1f5f9", c:"#475569" };
                    let changes = row.changes;
                    if (typeof changes === "string") { try { changes = JSON.parse(changes); } catch { changes = null; } }
                    const changeEntries = changes && typeof changes === "object" ? Object.entries(changes) : [];
                    return (
                      <tr key={row.id} style={{ borderBottom:"1px solid #f1f5f9" }}>
                        <td style={{ ...tdS, whiteSpace:"nowrap", color:"#64748b", fontSize:11 }}>
                          {String(row.created_at).slice(0,10)}<br/>{String(row.created_at).slice(11,16)}
                        </td>
                        <td style={{ ...tdS, fontWeight:600, fontSize:12 }}>{row.user_display_name || row.user_email || "—"}</td>
                        <td style={tdS}>
                          <span style={{ background:act.bg, color:act.c, padding:"2px 10px", borderRadius:12, fontSize:11, fontWeight:700, whiteSpace:"nowrap" }}>{act.l}</span>
                        </td>
                        <td style={{ ...tdS, fontWeight:700, fontSize:12 }}>
                          {row.entity_label || "—"}
                          {row.entity_id ? <span style={{ color:"#94a3b8", fontWeight:500, fontSize:10 }}> #{row.entity_id}</span> : null}
                        </td>
                        <td style={{ ...tdS, fontSize:11 }}>
                          {changeEntries.length === 0 ? <span style={{ color:"#cbd5e1" }}>—</span> : (
                            <div style={{ display:"grid", gap:2 }}>
                              {changeEntries.slice(0,6).map(([k, v]) => (
                                <div key={k} style={{ color:"#475569" }}>
                                  <span style={{ fontWeight:700 }}>{k}:</span>{" "}
                                  <span style={{ color:"#991b1b", textDecoration:"line-through" }}>{String(v?.old ?? "—")}</span>
                                  {" ← "}
                                  <span style={{ color:"#166534", fontWeight:600 }}>{String(v?.new ?? "—")}</span>
                                </div>
                              ))}
                              {changeEntries.length > 6 && <div style={{ color:"#94a3b8" }}>+{changeEntries.length - 6} تغييرات أخرى</div>}
                            </div>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>
        </div>
        </div>
      )}

      {/* Search + Filter Bar */}
      <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:14 }}>
        <select value={filterField} onChange={e => setFilterField(e.target.value)}
          style={{ padding:"8px 10px", border:"1px solid #e2e8f0", borderRadius:8, fontFamily:"inherit", fontSize:12, background:"#fff", color:"#475569", cursor:"pointer" }}>
          <option value="all">🔍 كل الحقول</option>
          <option value="name">الاسم</option>
          <option value="phone">الهاتف</option>
          <option value="notes">الملاحظات</option>
        </select>
        <div style={{ flex:1, display:"flex", alignItems:"center", gap:8, background:"#fff", border:"1px solid #e2e8f0", borderRadius:8, padding:"0 12px" }}>
          <FiUser size={14} color="#94a3b8" />
          <input value={search} onChange={e => setSearch(e.target.value)} placeholder="بحث..."
            style={{ border:"none", outline:"none", padding:"9px 0", width:"100%", fontFamily:"inherit", fontSize:13, background:"none" }} />
          {search && <button onClick={() => setSearch("")} style={{ background:"none", border:"none", color:"#94a3b8", cursor:"pointer", fontSize:14 }}>✕</button>}
        </div>
        <span style={{ fontSize:11, color:"#94a3b8", whiteSpace:"nowrap" }}>
          {filteredItems.length !== items.length ? `${filteredItems.length} / ${items.length}` : `${items.length}`} نتيجة
        </span>
        {/* Column visibility toggle — all types */}
        <div style={{ position:"relative" }}>
          <button onClick={() => setShowColMenu(!showColMenu)} title="إخفاء/إظهار أعمدة"
            style={{ padding:"6px 10px", background:"#f8fafc", border:"1px solid #e2e8f0", borderRadius:6, cursor:"pointer", fontSize:11, fontFamily:"inherit", color:"#64748b", display:"flex", alignItems:"center", gap:4 }}>
            📋 أعمدة <span style={{ fontSize:9, background:"#e0e7ff", color:"#3730a3", borderRadius:4, padding:"1px 4px" }}>{activeColDefs.length - hiddenCols.length}</span>
          </button>
          {showColMenu && (
            <div style={{ position:"absolute", left:0, top:"100%", marginTop:4, background:"#fff", border:"1px solid #e2e8f0", borderRadius:8, boxShadow:"0 8px 24px rgba(0,0,0,0.12)", padding:10, zIndex:100, minWidth:160 }}>
              {activeColDefs.map(c => (
                <label key={c.key} style={{ display:"flex", alignItems:"center", gap:6, padding:"4px 0", cursor:"pointer", fontSize:11 }}>
                  <input type="checkbox" checked={!hiddenCols.includes(c.key)} onChange={() => toggleCol(c.key)} style={{ accentColor:"#166534" }} />
                  {c.label}
                </label>
              ))}
                <div style={{ borderTop:"1px solid #e2e8f0", marginTop:6, paddingTop:6, display:"flex", gap:4 }}>
                  <button onClick={() => { setHiddenCols([]); try{localStorage.removeItem(storageKey)}catch{} }} style={{ fontSize:10, color:"#2563eb", background:"none", border:"none", cursor:"pointer" }}>الكل</button>
                  <button onClick={() => setShowColMenu(false)} style={{ fontSize:10, color:"#64748b", background:"none", border:"none", cursor:"pointer" }}>إغلاق</button>
                </div>
              </div>
            )}
          </div>
      </div>

      {/* Quick Filters for Clients — Multi-select */}
      {type === "client" && (() => {
        const activeFilters = (qfCompany ? 1 : 0) + (qfCategories.length > 0 ? 1 : 0) + (qfStages.length > 0 ? 1 : 0) + (qfSources.length > 0 ? 1 : 0) + (qfInterests.length > 0 ? 1 : 0);
        const btn = (active, label, onClick, color) => (
          <button onClick={onClick}
            style={{ padding:"3px 10px", borderRadius:14, border: active ? `2px solid ${color}` : "1px solid #e2e8f0",
              background: active ? (color === "#166534" ? "#dcfce7" : color === "#92400e" ? "#fef3c7" : color === "#3730a3" ? "#e0e7ff" : color === "#1d4ed8" ? "#dbeafe" : color === "#7c3aed" ? "#ede9fe" : "#f8fafc") : "#fff",
              color: active ? color : "#94a3b8", fontSize:11, fontWeight: active ? 700 : 400, cursor:"pointer", fontFamily:"inherit" }}>
            {label}
          </button>
        );
        return (
          <div style={{ display:"flex", flexDirection:"column", gap:6, marginBottom:10 }}>
            {activeFilters > 0 && (
              <div style={{ display:"flex", justifyContent:"flex-end" }}>
                <button onClick={() => { setQfCompany(""); setQfCategories([]); setQfStages([]); setQfSources([]); setQfInterests([]); }}
                  style={{ fontSize:10, color:"#dc2626", background:"none", border:"1px solid #fecaca", borderRadius:6, padding:"2px 8px", cursor:"pointer", fontFamily:"inherit" }}>✕ مسح جميع الفلاتر ({activeFilters})</button>
              </div>
            )}
            {/* عميل الشركة */}
            <div style={{ display:"flex", gap:5, flexWrap:"wrap", alignItems:"center" }}>
              <span style={{ fontSize:10, color:"#64748b", fontWeight:600, minWidth:80 }}>🏢 عميل الشركة</span>
              {[{v:"",l:"الكل"},{v:"yes",l:"نعم"},{v:"no",l:"لا"}].map(f => btn(qfCompany===f.v, f.l, () => setQfCompany(f.v), "#166534"))}
            </div>
            {/* نوع العميل — multi */}
            <div style={{ display:"flex", gap:5, flexWrap:"wrap", alignItems:"center" }}>
              <span style={{ fontSize:10, color:"#64748b", fontWeight:600, minWidth:80 }}>👤 نوع العميل</span>
              {btn(qfCategories.length===0, "الكل", () => setQfCategories([]), "#92400e")}
              {(allOptions?.client_category||[]).map(o => btn(qfCategories.includes(o.label), o.label, () => toggleMulti(setQfCategories, o.label), "#92400e"))}
            </div>
            {/* تصنيف العميل — multi */}
            <div style={{ display:"flex", gap:5, flexWrap:"wrap", alignItems:"center" }}>
              <span style={{ fontSize:10, color:"#64748b", fontWeight:600, minWidth:80 }}>🏷 تصنيف العميل</span>
              {btn(qfStages.length===0, "الكل", () => setQfStages([]), "#3730a3")}
              {(allOptions?.client_stage||[]).map(o => btn(qfStages.includes(o.label), o.label, () => toggleMulti(setQfStages, o.label), "#3730a3"))}
            </div>
            {/* مصدر العميل — multi */}
            <div style={{ display:"flex", gap:5, flexWrap:"wrap", alignItems:"center" }}>
              <span style={{ fontSize:10, color:"#64748b", fontWeight:600, minWidth:80 }}>📋 مصدر العميل</span>
              {btn(qfSources.length===0, "الكل", () => setQfSources([]), "#1d4ed8")}
              {(allOptions?.client_type||[]).map(o => btn(qfSources.includes(o.label), o.label, () => toggleMulti(setQfSources, o.label), "#1d4ed8"))}
            </div>
            {/* الاهتمامات — multi */}
            <div style={{ display:"flex", gap:5, flexWrap:"wrap", alignItems:"center" }}>
              <span style={{ fontSize:10, color:"#64748b", fontWeight:600, minWidth:80 }}>🎯 الاهتمامات</span>
              {btn(qfInterests.length===0, "الكل", () => setQfInterests([]), "#7c3aed")}
              {[...(allOptions?.client_interests_districts||[]).map(o=>o.label), ...(allOptions?.client_interests_project_types||[]).map(o=>o.label), ...(allOptions?.client_interests_unit_types||[]).map(o=>o.label)].map(label =>
                btn(qfInterests.includes(label), label, () => toggleMulti(setQfInterests, label), "#7c3aed")
              )}
            </div>
          </div>
        );
      })()}

      {/* Quick Filters for Marketers */}
      {type === "marketer" && (() => {
        const uniqueInterests = [...new Set(items.flatMap(i => {
          let tags = [];
          try { tags = i.interests ? (typeof i.interests === "string" ? JSON.parse(i.interests) : i.interests) : []; } catch {}
          return Array.isArray(tags) ? tags : [];
        }))].sort();
        const activeFilters = qfMktInterests.length > 0 ? 1 : 0; // v3.4.606 — أُزيل فلتر الشركة (يبقى من رأس عمود «شركة المسوق»)
        const btn = (active, label, onClick, color) => (
          <button onClick={onClick}
            style={{ padding:"3px 10px", borderRadius:14, border: active ? `2px solid ${color}` : "1px solid #e2e8f0",
              background: active ? (color === "#a21caf" ? "#fae8ff" : color === "#7c3aed" ? "#ede9fe" : "#f8fafc") : "#fff",
              color: active ? color : "#94a3b8", fontSize:11, fontWeight: active ? 700 : 400, cursor:"pointer", fontFamily:"inherit" }}>
            {label}
          </button>
        );
        return uniqueInterests.length > 0 ? (
          <div style={{ display:"flex", flexDirection:"column", gap:6, marginBottom:10 }}>
            {activeFilters > 0 && (
              <div style={{ display:"flex", justifyContent:"flex-end" }}>
                <button onClick={() => setQfMktInterests([])}
                  style={{ fontSize:10, color:"#dc2626", background:"none", border:"1px solid #fecaca", borderRadius:6, padding:"2px 8px", cursor:"pointer", fontFamily:"inherit" }}>✕ مسح جميع الفلاتر ({activeFilters})</button>
              </div>
            )}
            {uniqueInterests.length > 0 && (
              <div style={{ display:"flex", gap:5, flexWrap:"wrap", alignItems:"center" }}>
                <span style={{ fontSize:10, color:"#64748b", fontWeight:600, minWidth:80 }}>🏷 الاهتمامات</span>
                {btn(qfMktInterests.length===0, "الكل", () => setQfMktInterests([]), "#7c3aed")}
                {uniqueInterests.map(t => btn(qfMktInterests.includes(t), t, () => toggleMulti(setQfMktInterests, t), "#7c3aed"))}
              </div>
            )}
          </div>
        ) : null;
      })()}

      {/* Quick Filters for Developers */}
      {type === "developer" && (() => {
        const hasAnyCompanyProject = items.some(i => i.is_company_project);
        if (!hasAnyCompanyProject && !qfDevCompanyProject) return null;
        const activeFilters = qfDevCompanyProject ? 1 : 0;
        const btn = (active, label, onClick, color) => (
          <button onClick={onClick}
            style={{ padding:"3px 10px", borderRadius:14, border: active ? `2px solid ${color}` : "1px solid #e2e8f0",
              background: active ? "#dcfce7" : "#fff",
              color: active ? color : "#94a3b8", fontSize:11, fontWeight: active ? 700 : 400, cursor:"pointer", fontFamily:"inherit" }}>
            {label}
          </button>
        );
        return (
          <div style={{ display:"flex", flexDirection:"column", gap:6, marginBottom:10 }}>
            {activeFilters > 0 && (
              <div style={{ display:"flex", justifyContent:"flex-end" }}>
                <button onClick={() => setQfDevCompanyProject("")}
                  style={{ fontSize:10, color:"#dc2626", background:"none", border:"1px solid #fecaca", borderRadius:6, padding:"2px 8px", cursor:"pointer", fontFamily:"inherit" }}>✕ مسح الفلتر</button>
              </div>
            )}
            <div style={{ display:"flex", gap:5, flexWrap:"wrap", alignItems:"center" }}>
              <span style={{ fontSize:10, color:"#64748b", fontWeight:600, minWidth:80 }}>🏗️ مشروع الشركة</span>
              {[{v:"",l:"الكل"},{v:"yes",l:"نعم"},{v:"no",l:"لا"}].map(f => btn(qfDevCompanyProject===f.v, f.l, () => setQfDevCompanyProject(f.v), "#166534"))}
            </div>
          </div>
        );
      })()}

      {/* Table */}
      <div style={{ background:"#fff", border:"1px solid #e2e8f0", borderRadius:10, overflow:"hidden" }}>
        <table style={{ width:"100%", borderCollapse:"collapse", fontSize:13 }}>
          <thead>
            <tr style={{ background:"#f8fafc" }}>
              <th style={{ ...thS, width:40 }}>
                <button onClick={toggleSelectAll} title="تحديد الكل"
                  style={{ background:"none", border:"none", cursor:"pointer", color: allSelected?"#2563eb": someSelected?"#93c5fd":"#94a3b8", display:"flex", alignItems:"center" }}>
                  {allSelected ? <FiCheckSquare size={16} /> : someSelected ? <FiCheckSquare size={16} style={{ opacity:0.5 }} /> : <FiSquare size={16} />}
                </button>
              </th>
              {/* v3.3.670 — رؤوس قابلة للفرز */}
              <SortTh label="ID#" k="id" />
              <SortTh label={type === "client" ? "اسم العميل" : type === "developer" ? "اسم المطور" : "اسم المسوق"} k="name" filter />

              {type === "client" && <>
                {isColVisible("client_number") && <SortTh label="رقم الهوية" k="client_number" />}
                {isColVisible("phone") && <SortTh label="الهاتف" k="phone" />}
                {isColVisible("is_company_client") && <SortTh label="عميل الشركة" k="is_company_client" filter />}
                {isColVisible("client_category") && <SortTh label="نوع العميل" k="client_category" filter />}
                {isColVisible("client_stage") && <SortTh label="تصنيف العميل" k="client_stage" filter />}
                {isColVisible("client_type") && <SortTh label="مصدر العميل" k="client_type" filter />}
                {isColVisible("iban") && <SortTh label="IBAN" k="iban" />}
                {isColVisible("visit_count") && <SortTh label="الزيارات" k="visit_count" />}
                {isColVisible("notes") && <SortTh label="ملاحظات" k="notes" />}
              </>}
              {type === "developer" && <>
                {isColVisible("representative_name") && <SortTh label="ممثل المطور" k="representative_name" filter />}
                {isColVisible("representative_phone") && <SortTh label="رقم الممثل" k="representative_phone" />}
                {isColVisible("is_company_project") && <SortTh label="مشروع الشركة" k="is_company_project" filter />}
                {isColVisible("notes") && <SortTh label="ملاحظات" k="notes" />}
              </>}
              {type === "marketer" && <>
                {isColVisible("phone") && <SortTh label="الهاتف" k="phone" />}
                {isColVisible("office") && <SortTh label="شركة المسوق" k="office" filter />}
                {isColVisible("interests") && <SortTh label="اهتمامات" k="interests" />}
                {/* v3.3.671 — كانت خلايا الحجوزات/المبيعات (v3.3.486) بلا رؤوس فتنزاح الأعمدة */}
                {isColVisible("reservations_count") && <SortTh label="الحجوزات" k="reservations_count" />}
                {isColVisible("sales_count") && <SortTh label="المبيعات" k="sales_count" />}
                {isColVisible("notes") && <SortTh label="ملاحظات" k="notes" />}
              </>}

              <SortTh label="تاريخ الإضافة" k="created_at" />
              <th style={{ ...thS, width:50 }}></th>
            </tr>
          </thead>
          <tbody>
            {filteredItems.length === 0 ? (
              <tr><td colSpan={8} style={{ textAlign:"center", padding:30, color:"#94a3b8" }}>{search?"لا توجد نتائج":"لم تتم إضافة أي عنصر بعد"}</td></tr>
            ) : sortedItems.map((item, idx) => (
              <tr key={item.id}
                onDoubleClick={() => setEntityPanel({ ...item })}
                style={{ borderBottom:"1px solid #f1f5f9", background: selected.has(item.id)?"#eff6ff":undefined, cursor:"default" }}>
                <td style={{ ...tdS, textAlign:"center" }}>
                  <button onClick={() => toggleOne(item.id)} style={{ background:"none", border:"none", cursor:"pointer", color: selected.has(item.id)?"#2563eb":"#94a3b8", display:"flex", alignItems:"center" }}>
                    {selected.has(item.id) ? <FiCheckSquare size={15} /> : <FiSquare size={15} />}
                  </button>
                </td>
                <td style={tdS}>
                  <span style={{ 
                    background: type === "client" ? "#e0e7ff" : type === "developer" ? "#dcfce7" : "#fae8ff", 
                    color: type === "client" ? "#4338ca" : type === "developer" ? "#166534" : "#a21caf", 
                    padding:"2px 6px", 
                    borderRadius:4, 
                    fontSize:11, 
                    fontWeight:700, 
                    fontFamily:"monospace" 
                  }}>#{item.id}</span>
                </td>

                {/* Name — clickable */}
                <td style={tdS}>
                  <span style={{ fontWeight:600, cursor:"pointer", color:"#1e293b" }}
                    onDoubleClick={() => setEntityPanel({ ...item })}>
                    {item.name}
                  </span>
                </td>

                {type === "client" && <>
                  {isColVisible("client_number") && <td style={tdS}><span style={{ color:"#64748b", fontSize:12 }}>{item.client_number || <span style={{color:"#d1d5db"}}>—</span>}</span></td>}
                  {isColVisible("phone") && <td style={tdS}>{item.phone ? <span style={{ color:"#0891b2", fontSize:12 }}>{item.phone}</span> : <span style={{color:"#d1d5db"}}>—</span>}</td>}
                  {isColVisible("is_company_client") && <td style={tdS}>{item.is_company_client ? <span style={{ background:"#dcfce7", color:"#166534", borderRadius:12, padding:"2px 8px", fontSize:10, fontWeight:700 }}>نعم</span> : <span style={{ background:"#f1f5f9", color:"#94a3b8", borderRadius:12, padding:"2px 8px", fontSize:10 }}>لا</span>}</td>}
                  {isColVisible("client_category") && <td style={tdS}>{item.client_category ? <span style={{ background:"#fef3c7", color:"#92400e", borderRadius:12, padding:"2px 8px", fontSize:11, fontWeight:600 }}>{item.client_category}</span> : <span style={{color:"#d1d5db"}}>—</span>}</td>}
                  {isColVisible("client_stage") && <td style={tdS}>{item.client_stage ? <span style={{ background:"#e0e7ff", color:"#3730a3", borderRadius:12, padding:"2px 8px", fontSize:11, fontWeight:600 }}>{item.client_stage}</span> : <span style={{color:"#d1d5db"}}>—</span>}</td>}
                  {isColVisible("client_type") && <td style={tdS}>{item.client_type ? <span style={{ background:"#eff6ff", color:"#1d4ed8", borderRadius:12, padding:"2px 8px", fontSize:11, fontWeight:600 }}>{item.client_type}</span> : <span style={{color:"#d1d5db"}}>—</span>}</td>}
                  {isColVisible("iban") && <td style={tdS}><span style={{ color:"#64748b", fontSize:11, direction:"ltr" }}>{item.iban || <span style={{color:"#d1d5db"}}>—</span>}</span></td>}
                  {isColVisible("visit_count") && <td style={tdS}><span style={{ color:"#64748b", fontSize:12 }}>{item.visit_count || 0}</span></td>}
                  {isColVisible("notes") && <td style={tdS}><span style={{ color:"#64748b", fontSize:12, maxWidth:120, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", display:"inline-block" }}>{item.notes || <span style={{color:"#d1d5db"}}>—</span>}</span></td>}
                </>}

                {type === "developer" && <>
                  {isColVisible("representative_name") && <td style={tdS}><span style={{ color:"#1e293b", fontSize:12 }}>{item.representative_name || <span style={{color:"#d1d5db"}}>—</span>}</span></td>}
                  {isColVisible("representative_phone") && <td style={tdS}>{item.representative_phone ? <span style={{ display:"flex", alignItems:"center", gap:4, color:"#0891b2" }}><FiPhone size={12}/>{item.representative_phone}</span> : <span style={{color:"#d1d5db"}}>—</span>}</td>}
                  {isColVisible("is_company_project") && <td style={tdS}>{item.is_company_project ? <span style={{ background:"#dcfce7", color:"#166534", borderRadius:12, padding:"2px 8px", fontSize:10, fontWeight:700 }}>نعم</span> : <span style={{ background:"#f1f5f9", color:"#94a3b8", borderRadius:12, padding:"2px 8px", fontSize:10 }}>لا</span>}</td>}
                  {isColVisible("notes") && <td style={tdS}><span style={{ color:"#64748b", fontSize:12 }}>{item.notes || <span style={{color:"#d1d5db"}}>—</span>}</span></td>}
                </>}

                {type === "marketer" && (() => {
                  let tags = [];
                  try { tags = item.interests ? (typeof item.interests === "string" ? JSON.parse(item.interests) : item.interests) : []; } catch(e){}
                  return <>
                    {isColVisible("phone") && <td style={tdS}>{item.phone ? <span style={{ display:"flex", alignItems:"center", gap:4, color:"#0891b2" }}><FiPhone size={12}/>{item.phone}</span> : <span style={{color:"#d1d5db"}}>—</span>}</td>}
                    {isColVisible("office") && <td style={tdS}><span style={{ color:"#64748b", fontSize:12 }}>{item.office || <span style={{color:"#d1d5db"}}>—</span>}</span></td>}
                    {isColVisible("interests") && <td style={tdS}>
                      {tags.length > 0
                        ? <div style={{ display:"flex", gap:3, flexWrap:"wrap" }}>{tags.slice(0,3).map((t,i)=><span key={i} style={{ background:"#e0e7ff", color:"#3730a3", borderRadius:8, padding:"1px 6px", fontSize:10, fontWeight:600 }}>{t}</span>)}{tags.length>3&&<span style={{fontSize:10,color:"#94a3b8"}}>+{tags.length-3}</span>}</div>
                        : <span style={{color:"#d1d5db"}}>—</span>}
                    </td>}
                    {/* v3.3.486 — Reservations & sales counts */}
                    {isColVisible("reservations_count") && <td style={{ ...tdS, textAlign: "center" }}>
                      {Number(item.reservations_count) > 0
                        ? <span style={{ background:"#dbeafe", color:"#1e40af", borderRadius:8, padding:"2px 8px", fontSize:11, fontWeight:700 }}>{item.reservations_count}</span>
                        : <span style={{color:"#d1d5db"}}>0</span>}
                    </td>}
                    {isColVisible("sales_count") && <td style={{ ...tdS, textAlign: "center" }}>
                      {Number(item.sales_count) > 0
                        ? <span style={{ background:"#dcfce7", color:"#15803d", borderRadius:8, padding:"2px 8px", fontSize:11, fontWeight:700 }}>{item.sales_count}</span>
                        : <span style={{color:"#d1d5db"}}>0</span>}
                    </td>}
                    {isColVisible("notes") && <td style={tdS}><span style={{ color:"#64748b", fontSize:12 }}>{item.notes || <span style={{color:"#d1d5db"}}>—</span>}</span></td>}
                  </>;
                })()}

                <td style={tdS}><span style={{ color:"#94a3b8", fontSize:11 }}>{item.created_at ? new Date(item.created_at).toLocaleDateString("en-GB") : "—"}</span></td>

                {/* Gear icon — opens panel */}
                <td style={{ ...tdS, textAlign:"center" }}>
                  <button
                    onClick={() => setEntityPanel({ ...item })}
                    title="فتح / تعديل / حذف"
                    style={{ background:"none", border:"1px solid #e2e8f0", borderRadius:6, padding:"4px 6px", cursor:"pointer", color:"#64748b", display:"flex", alignItems:"center", justifyContent:"center", transition:"all 0.15s" }}
                    onMouseEnter={e => { e.currentTarget.style.background="#f1f5f9"; e.currentTarget.style.color="#1e293b"; }}
                    onMouseLeave={e => { e.currentTarget.style.background="none"; e.currentTarget.style.color="#64748b"; }}>
                    <FiSettings size={14} />
                  </button>
                </td>
              </tr>
            ))}

          </tbody>
        </table>
      </div>
      <div style={{ fontSize:11, color:"#94a3b8", marginTop:10 }}>
        💡 لرفع ملف CSV: الأعمدة بالترتيب → الاسم, الهاتف, ملاحظات
      </div>
    </div>

    {entityPanel && <RefEntityPanel entity={entityPanel} entityType={type} onClose={() => setEntityPanel(null)} onUpdated={() => { fetchItems(); setEntityPanel(null); }} canViewReservations={canViewReservations} />}
    </>
  );
}

// Mini reservations panel for ref pages
function RefEntityPanel({ entity, entityType, onClose, onUpdated, canViewReservations = false }) {
  const [reservations, setReservations] = useState([]);
  const [loading, setLoading] = useState(!canViewReservations); // If can't view, don't show loading
  const [editing, setEditing] = useState(false);
  const [selectedRes, setSelectedRes] = useState(null);
  const [projectsList, setProjectsList] = useState([]);
  const [allOptions, setAllOptions] = useState({});
  const [clientStats, setClientStats] = useState(null);
  const [clientUnits, setClientUnits] = useState([]);
  const [activeTab, setActiveTab] = useState("reservations");
  // v3.3.743 — نموذج موحّد للعرض والتعديل: نفس الحقول، العرض قراءة فقط بحجم أصغر
  const buildEditData = (e) => ({
    name: e.name,
    phone: e.phone || "",
    // Shared fields (clients + marketers)
    // v3.3.537 — merged duplicates: iban and visit_count are shared by clients and marketers
    iban: e.iban || "",
    visit_count: e.visit_count || 0,
    // Client-specific fields
    client_number: e.client_number || "",
    client_type: e.client_type || "",
    classification: e.classification || "",
    client_category: e.client_category || "",
    client_stage: e.client_stage || "",
    interests: e.interests ? (typeof e.interests === "string" ? JSON.parse(e.interests) : e.interests) : {},
    is_company_client: e.is_company_client || false,
    // Marketer fields
    office: e.office || "",
    company: e.office || "",
    nationality: e.nationality || "",
    marketer_classification: e.marketer_classification || "",
    bank_name: e.bank_name || "",
    id_number: e.id_number || "",
    email: e.email || "", national_address: e.national_address || "", landline: e.landline || "", // v3.4.634 — للعميل (عقود وافي)
    // Developer fields
    representative_name: e.representative_name || "",
    representative_phone: e.representative_phone || "",
    is_company_project: e.is_company_project || false,
    linked_project_id: e.linked_project_id || null,
    // Common fields
    notes: e.notes || ""
  });
  const [editData, setEditData] = useState(buildEditData(entity));
  // مزامنة النموذج عند تغيّر السجل (والعرض غير قابل للتعديل)
  useEffect(() => { if (!editing) setEditData(buildEditData(entity)); /* eslint-disable-next-line */ }, [entity]);
  const [saving, setSaving] = useState(false);
  // ── المجموعات (مسوقين / عملاء) ──
  const [allGroups, setAllGroups] = useState([]);       // كل المجموعات المتاحة
  const [memberGroupIds, setMemberGroupIds] = useState(new Set()); // المجموعات المنضم لها
  const [loadingGroups, setLoadingGroups] = useState(false);
  const [togglingGroup, setTogglingGroup] = useState(null); // id المجموعة اللي يتم تعديلها حالياً

  // سحب المجموعات عند فتح البانل
  useEffect(() => {
    if (entityType !== "developer" && entity.id) {
      setLoadingGroups(true);
      const grpApi = entityType === "marketer" ? mgApi : cgApi;
      const getEntityGroups = entityType === "marketer" ? mgApi.getMarketerGroups : cgApi.getClientGroups;
      Promise.all([
        grpApi.list(),
        getEntityGroups(entity.id),
      ]).then(([allRes, memberRes]) => {
        setAllGroups(allRes.data?.groups || []);
        const ids = (memberRes.data?.groups || []).map(g => g.id);
        setMemberGroupIds(new Set(ids));
      }).catch(() => {}).finally(() => setLoadingGroups(false));
    }
  }, [entity.id, entityType]);

  const toggleGroup = async (groupId, isCurrentlyMember) => {
    setTogglingGroup(groupId);
    const grpApi = entityType === "marketer" ? mgApi : cgApi;
    try {
      if (isCurrentlyMember) {
        await grpApi.removeMember(groupId, entity.id);
        setMemberGroupIds(prev => { const n = new Set(prev); n.delete(groupId); return n; });
        toast.success("تمت الإزالة من المجموعة");
      } else {
        const ids = entityType === "marketer" ? [entity.id] : [entity.id];
        await grpApi.addMembers(groupId, ids);
        setMemberGroupIds(prev => new Set([...prev, groupId]));
        toast.success("تمت الإضافة للمجموعة");
      }
    } catch (e) {
      toast.error("فشل تعديل المجموعة");
    }
    setTogglingGroup(null);
  };

  // Load dropdown options for edit form
  useEffect(() => {
    refApi.getAllOptions().then(r => setAllOptions(r.data.options || {})).catch(() => {});
    if (entityType === "client" && entity.id) {
      refApi.getClientStats(entity.id).then(r => setClientStats(r.data)).catch(() => {});
      refApi.getClientUnits(entity.id).then(r => setClientUnits(r.data.units || [])).catch(() => {});
    }
  }, [entity.id, entityType]);

  const typeLabel = entityType === "marketer" ? "مسوق" : entityType === "developer" ? "مطور / شركة تطوير" : "عميل";
  const typeIcon = entityType === "marketer" ? "📢" : entityType === "developer" ? "🏗️" : "👤";
  const hasPhone = entityType !== "developer";
  const hasOffice = false; // replaced by company for marketers

  useEffect(() => {
    // Only fetch reservations if user has permission
    if (canViewReservations && entity.id) {
      setLoading(true);
      const params = { limit: 9999 };
      // Use linked IDs for actual junction table links
      if (entityType === "marketer") params.linked_marketer_id = entity.id;
      else if (entityType === "developer") params.linked_developer_id = entity.id;
      else params.linked_client_id = entity.id;
      resApi.list(params).then(r => { setReservations(r.data.reservations || []); setLoading(false); })
        .catch(() => setLoading(false));
    }
    
    // Load projects list for developer linking and client interests
    if (entityType === "developer" || entityType === "client") {
      refApi.getProjectsList().then(r => setProjectsList(r.data.items || [])).catch(() => {});
    }
  }, [entity, entityType, canViewReservations]);

  const fmt = n => Number(n || 0).toLocaleString("en-US");
  const totalValue = reservations.reduce((s, r) => s + (Number(r.value) || 0), 0);
  const totalDalala = reservations.reduce((s, r) => s + (Number(r.dalala_amount) || 0), 0);
  const completed = reservations.filter(r => r.operation_status === "تمت العمليه").length;

  const handleSave = async () => {
    if (!editData.name.trim()) { alert("الاسم مطلوب"); return; }
    setSaving(true);
    try {
      const updateFn = entityType === "marketer" ? refApi.updateMarketer : entityType === "developer" ? refApi.updateDeveloper : refApi.updateClient;

      try { await updateFn(entity.id, editData); }
      catch (e) { // v3.4.743 — جوال مكرر مع مسوق آخر: تأكيد ثم تجاوز بـ force
        const d = e.response?.data; if (e.response?.status !== 409 || !d?.duplicate) throw e;
        const who = (d.existing || []).map((x) => `${x.name} (${x.phone || "بلا جوال"}) #${x.id}`).join("، ");
        if (!window.confirm(`يوجد مسوق آخر بنفس الجوال: ${who}\n\nهل تريد الحفظ رغم ذلك؟ (الأفضل دمج السجلين بزر «دمج»)`)) { setSaving(false); return; }
        await updateFn(entity.id, { ...editData, force: true });
      }
      setEditing(false);
      onUpdated && onUpdated();
      toast.success("تم الحفظ");
    } catch(e) { toast.error(e.response?.data?.error || "فشل الحفظ"); }
    setSaving(false);
  };

  // v3.4.743 — دمج هذا المسوق في مسوق آخر (نفس الشخص بسجلين)
  const handleMerge = async () => {
    const q = window.prompt(`دمج «${entity.name}» في مسوق آخر.\nاكتب رقم سجل المسوق الهدف (#) أو جواله أو اسمه بالضبط.\nستُنقل الحجوزات والمجموعات والعملاء المحتملون إلى الهدف ويُنقل هذا السجل إلى سلة المحذوفات.`);
    if (q == null || !q.trim()) return;
    const body = /^#?\d{1,6}$/.test(q.trim()) && q.trim().replace("#", "").length < 9 ? { target_id: Number(q.trim().replace("#", "")) } : { query: q.trim() };
    try {
      const r = await refApi.mergeMarketer(entity.id, body);
      const mv = r.data.moved || {};
      toast.success(`تم الدمج في «${r.data.target?.name}» — حجوزات ${mv.reservations || 0}، مجموعات ${mv.groups || 0}`);
      onUpdated && onUpdated(); onClose && onClose();
    } catch (e) {
      const d = e.response?.data;
      if (d?.candidates) toast.error(`أكثر من مطابق: ${d.candidates.map((x) => `#${x.id} ${x.name}`).join("، ")} — اكتب رقم السجل`);
      else toast.error(d?.error || "فشل الدمج");
    }
  };

  const handlePanelDelete = async () => {
    if (!window.confirm(`حذف "${entity.name}"؟\nهذا الإجراء لا يمكن التراجع عنه.`)) return;
    try {
      const delFn = entityType === "marketer" ? refApi.deleteMarketer : entityType === "developer" ? refApi.deleteDeveloper : refApi.deleteClient;
      await delFn(entity.id);
      toast.success("تم الحذف");
      onUpdated && onUpdated();
    } catch(e) { toast.error(e.response?.data?.error || "فشل الحذف"); }
  };

  const statusColor = (s) => s === "تمت العمليه" ? { bg:"#dcfce7", text:"#166534" } : s === "لم تتم العمليه" ? { bg:"#fee2e2", text:"#991b1b" } : { bg:"#fef3c7", text:"#92400e" };

  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(15,23,42,0.6)", zIndex:9999, display:"flex", justifyContent:"flex-end" }} onClick={onClose}>
      <div style={{ width:720, maxWidth:"95vw", background:"#fff", height:"100vh", overflowY:"auto", boxShadow:"-4px 0 40px rgba(0,0,0,0.2)" }} dir="rtl" onClick={e => e.stopPropagation()}>

        {/* ── Header with buttons ── */}
        <div style={{ padding:"12px 16px", background:"linear-gradient(135deg,#1e293b 0%,#334155 100%)", position:"sticky", top:0, zIndex:10 }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
            <div style={{ display:"flex", alignItems:"center", gap:10 }}>
              <span style={{ 
                background: entityType === "client" ? "#e0e7ff" : entityType === "developer" ? "#dcfce7" : "#fae8ff", 
                color: entityType === "client" ? "#4338ca" : entityType === "developer" ? "#166534" : "#a21caf", 
                padding:"3px 8px", 
                borderRadius:4, 
                fontSize:11, 
                fontWeight:700, 
                fontFamily:"monospace" 
              }}>#{entity.id}</span>
              <div>
                <div style={{ fontSize:9, color:"#94a3b8", marginBottom:1, textTransform:"uppercase", letterSpacing:0.5 }}>{typeIcon} {typeLabel}</div>
                <h2 style={{ margin:0, color:"#fff", fontSize:14, fontWeight:600 }}>{editing ? editData.name : entity.name}</h2>
              </div>
            </div>
            <div style={{ display:"flex", gap:5, alignItems:"center" }}>
              {/* v3.3.745 — حفظ/إلغاء في الأعلى أثناء التعديل */}
              {editing && (
                <>
                  <button onClick={handleSave} disabled={saving}
                    style={{ background:"#2563eb", border:"none", color:"#fff", padding:"4px 14px", borderRadius:4, cursor:"pointer", fontFamily:"inherit", fontSize:10, fontWeight:700, opacity:saving?0.7:1 }}>
                    {saving ? "جاري الحفظ..." : "💾 حفظ"}
                  </button>
                  <button onClick={() => { setEditing(false); setEditData(buildEditData(entity)); }}
                    style={{ background:"rgba(255,255,255,0.15)", border:"1px solid rgba(255,255,255,0.3)", color:"#e2e8f0", padding:"4px 12px", borderRadius:4, cursor:"pointer", fontFamily:"inherit", fontSize:10, fontWeight:600 }}>
                    إلغاء
                  </button>
                </>
              )}
              {!editing && (
                <button onClick={() => setEditing(true)}
                  style={{ background:"rgba(59,130,246,0.25)", border:"1px solid rgba(59,130,246,0.5)", color:"#93c5fd", padding:"4px 10px", borderRadius:4, cursor:"pointer", fontFamily:"inherit", fontSize:10, fontWeight:600, display:"flex", alignItems:"center", gap:3 }}>
                  <FiEdit2 size={11} /> تعديل
                </button>
              )}
              {!editing && entityType === "marketer" && (
                <button onClick={handleMerge} title="دمج هذا السجل في مسوق آخر (نفس الشخص بسجلين)"
                  style={{ background:"rgba(245,158,11,0.2)", border:"1px solid rgba(245,158,11,0.5)", color:"#fcd34d", padding:"4px 10px", borderRadius:4, cursor:"pointer", fontFamily:"inherit", fontSize:10, fontWeight:600, display:"flex", alignItems:"center", gap:4 }}>
                  ⇄ دمج
                </button>
              )}{/* v3.4.743 */}
              {!editing && (
                <button onClick={handlePanelDelete}
                  style={{ background:"rgba(239,68,68,0.2)", border:"1px solid rgba(239,68,68,0.5)", color:"#fca5a5", padding:"4px 10px", borderRadius:4, cursor:"pointer", fontFamily:"inherit", fontSize:10, fontWeight:600, display:"flex", alignItems:"center", gap:3 }}>
                  <FiTrash2 size={11} /> حذف
                </button>
              )}
              <button onClick={onClose} style={{ background:"rgba(255,255,255,0.1)", border:"none", color:"#fff", width:26, height:26, borderRadius:4, cursor:"pointer", fontSize:12, display:"flex", alignItems:"center", justifyContent:"center", marginRight:4 }}>✕</button>
            </div>
          </div>
        </div>

        {/* ── Info Card ── */}
        {/* v3.3.743 — نموذج موحّد: نفس ترتيب حقول التعديل في العرض، مصغّرة وللقراءة فقط،
            وزر "تعديل" يحوّل الحقول نفسها إلى قابلة للتعديل */}
        <div style={{ padding:"14px 20px", background:"#f8fafc", borderBottom:"1px solid #e2e8f0" }}>
          <style>{`
            .entity-form-ro input:disabled, .entity-form-ro select:disabled, .entity-form-ro textarea:disabled {
              background:#fbfcfe !important; border-color:#eef2f7 !important; color:#334155 !important;
              -webkit-text-fill-color:#334155; opacity:1 !important; padding:4px 8px !important;
              font-size:11px !important; cursor:default !important;
            }
            .entity-form-ro select:disabled { appearance:none; -webkit-appearance:none; }
            .entity-form-ro input[type=checkbox]:disabled { opacity:.85 !important; cursor:default !important; padding:0 !important; }
          `}</style>
          <fieldset disabled={!editing} className={editing ? "" : "entity-form-ro"} style={{ border:"none", padding:0, margin:0, minWidth:0 }}>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap: editing ? 10 : 7 }}>
              <div>
                <label style={{ fontSize:10, color:"#64748b", fontWeight:600, display:"block", marginBottom:3 }}>الاسم *</label>
                <input value={editData.name} onChange={e => setEditData(d => ({...d, name:e.target.value}))}
                  style={{ width:"100%", padding:"7px 10px", border:"1px solid #93c5fd", borderRadius:6, fontFamily:"inherit", fontSize:12, outline:"none", boxSizing:"border-box" }} />
              </div>
              {hasPhone && <div>
                <label style={{ fontSize:10, color:"#64748b", fontWeight:600, display:"block", marginBottom:3 }}>الهاتف</label>
                {/* v3.3.749 — إدخال موحّد: تحويل الأرقام العربية، لا فراغات، تحقق السعودي، زر دولي */}
                <PhoneInput value={editData.phone} intl={editData._phone_intl || (editData.phone || "").startsWith("+")}
                  onChange={v => setEditData(d => ({...d, phone: v}))}
                  onIntlChange={v => setEditData(d => ({...d, _phone_intl: v}))}
                  disabled={!editing} />
              </div>}
              {/* Client-specific fields */}
              {entityType === "client" && <div style={{ gridColumn:"1/-1", display:"flex", alignItems:"center", gap:10, background: editData.is_company_client ? "#dcfce7" : "#f8fafc", border:"1px solid #e2e8f0", borderRadius:6, padding:"8px 12px" }}>
                <label style={{ display:"flex", alignItems:"center", gap:6, cursor:"pointer", fontSize:12 }}>
                  <input type="checkbox" checked={editData.is_company_client || false} onChange={e => setEditData(d => ({...d, is_company_client:e.target.checked}))} style={{ accentColor:"#166534" }} />
                  <span style={{ fontWeight:600, color: editData.is_company_client ? "#166534" : "#64748b" }}>🏢 عميل الشركة</span>
                </label>
              </div>}
              {entityType === "client" && <div>
                <label style={{ fontSize:10, color:"#64748b", fontWeight:600, display:"block", marginBottom:3 }}>🪪 رقم هوية العميل</label>
                <input value={editData.client_number} onChange={e => setEditData(d => ({...d, client_number:e.target.value}))} placeholder="رقم الهوية"
                  style={{ width:"100%", padding:"7px 10px", border:"1px solid #e2e8f0", borderRadius:6, fontFamily:"inherit", fontSize:12, outline:"none", boxSizing:"border-box" }} />
              </div>}
              {/* v3.4.634 — بيانات العميل لعقود وافي (تظهر مقفلة في العقد وتُعدَّل من هنا) */}
              {entityType === "client" && <div><label style={{ fontSize:10, color:"#64748b", fontWeight:600, display:"block", marginBottom:3 }}>🌍 الجنسية</label><input value={editData.nationality || ""} onChange={e => setEditData(d => ({...d, nationality:e.target.value}))} placeholder="سعودي" style={{ width:"100%", padding:"7px 10px", border:"1px solid #e2e8f0", borderRadius:6, fontFamily:"inherit", fontSize:12, outline:"none", boxSizing:"border-box" }} /></div>}
              {entityType === "client" && <div><label style={{ fontSize:10, color:"#64748b", fontWeight:600, display:"block", marginBottom:3 }}>☎️ الهاتف الثابت</label><input value={editData.landline || ""} onChange={e => setEditData(d => ({...d, landline:e.target.value}))} placeholder="012xxxxxxx" style={{ width:"100%", padding:"7px 10px", border:"1px solid #e2e8f0", borderRadius:6, fontFamily:"inherit", fontSize:12, outline:"none", boxSizing:"border-box", direction:"ltr", textAlign:"right" }} /></div>}
              {entityType === "client" && <div><label style={{ fontSize:10, color:"#64748b", fontWeight:600, display:"block", marginBottom:3 }}>✉️ البريد الإلكتروني</label><input value={editData.email || ""} onChange={e => setEditData(d => ({...d, email:e.target.value}))} placeholder="name@example.com" style={{ width:"100%", padding:"7px 10px", border:"1px solid #e2e8f0", borderRadius:6, fontFamily:"inherit", fontSize:12, outline:"none", boxSizing:"border-box", direction:"ltr", textAlign:"right" }} /></div>}
              {entityType === "client" && <div style={{ gridColumn:"1/-1" }}><label style={{ fontSize:10, color:"#64748b", fontWeight:600, display:"block", marginBottom:3 }}>📍 العنوان الوطني</label><input value={editData.national_address || ""} onChange={e => setEditData(d => ({...d, national_address:e.target.value}))} placeholder="رقم المبنى، الشارع، الحي، المدينة، الرمز البريدي" style={{ width:"100%", padding:"7px 10px", border:"1px solid #e2e8f0", borderRadius:6, fontFamily:"inherit", fontSize:12, outline:"none", boxSizing:"border-box" }} /></div>}
              {entityType === "client" && <div>
                <label style={{ fontSize:10, color:"#64748b", fontWeight:600, display:"block", marginBottom:3 }}>🏦 رقم IBAN</label>
                <input value={editData.iban} onChange={e => setEditData(d => ({...d, iban:e.target.value}))} placeholder="SA..."
                  style={{ width:"100%", padding:"7px 10px", border:"1px solid #e2e8f0", borderRadius:6, fontFamily:"inherit", fontSize:12, outline:"none", boxSizing:"border-box", direction:"ltr", textAlign:"right" }} />
              </div>}
              {entityType === "client" && <div>
                <label style={{ fontSize:10, color:"#64748b", fontWeight:600, display:"block", marginBottom:3 }}>مصدر العميل</label>
                <select value={editData.client_type} onChange={e => setEditData(d => ({...d, client_type:e.target.value}))}
                  style={{ width:"100%", padding:"7px 10px", border:"1px solid #e2e8f0", borderRadius:6, fontFamily:"inherit", fontSize:12, outline:"none", boxSizing:"border-box", background:"#fff" }}>
                  <option value="">— اختر —</option>
                  {(allOptions?.client_type||[]).map(o => <option key={o.id} value={o.label}>{o.label}</option>)}
                </select>
              </div>}
              {entityType === "client" && <div>
                <label style={{ fontSize:10, color:"#64748b", fontWeight:600, display:"block", marginBottom:3 }}>👤 نوع العميل</label>
                <select value={editData.client_category} onChange={e => setEditData(d => ({...d, client_category:e.target.value}))}
                  style={{ width:"100%", padding:"7px 10px", border:"1px solid #e2e8f0", borderRadius:6, fontFamily:"inherit", fontSize:12, outline:"none", boxSizing:"border-box", background:"#fff" }}>
                  <option value="">— اختر —</option>
                  {(allOptions?.client_category||[]).map(o => <option key={o.id} value={o.label}>{o.label}</option>)}
                </select>
              </div>}
              {entityType === "client" && <div>
                <label style={{ fontSize:10, color:"#64748b", fontWeight:600, display:"block", marginBottom:3 }}>🏷 تصنيف العميل</label>
                <select value={editData.client_stage} onChange={e => setEditData(d => ({...d, client_stage:e.target.value}))}
                  style={{ width:"100%", padding:"7px 10px", border:"1px solid #e2e8f0", borderRadius:6, fontFamily:"inherit", fontSize:12, outline:"none", boxSizing:"border-box", background:"#fff" }}>
                  <option value="">— اختر —</option>
                  {(allOptions?.client_stage||[]).map(o => <option key={o.id} value={o.label}>{o.label}</option>)}
                </select>
              </div>}
              {entityType === "client" && <div>
                <label style={{ fontSize:10, color:"#64748b", fontWeight:600, display:"block", marginBottom:3 }}>🏠 عدد الزيارات</label>
                <input type="number" value={editData.visit_count} onChange={e => setEditData(d => ({...d, visit_count:parseInt(e.target.value)||0}))}
                  style={{ width:"100%", padding:"7px 10px", border:"1px solid #e2e8f0", borderRadius:6, fontFamily:"inherit", fontSize:12, outline:"none", boxSizing:"border-box" }} />
              </div>}
              {/* اهتمامات العميل — Checklist */}
              {entityType === "client" && (() => {
                const int = editData.interests || {};
                const toggle = (cat, val) => {
                  setEditData(d => {
                    const cur = d.interests || {};
                    const arr = cur[cat] || [];
                    const next = arr.includes(val) ? arr.filter(v => v !== val) : [...arr, val];
                    return { ...d, interests: { ...cur, [cat]: next } };
                  });
                };
                const cbs = { fontSize:10, display:"flex", alignItems:"center", gap:4, cursor:"pointer", padding:"2px 0" };
                const cbx = (cat, val) => <label key={val} style={cbs}><input type="checkbox" checked={(int[cat]||[]).includes(val)} onChange={() => toggle(cat, val)} style={{ accentColor:"#166534" }} /><span>{val}</span></label>;
                // v3.3.745 — في العرض: شارات الاهتمامات المفعّلة فقط؛ القوائم الكاملة عند التعديل
                if (!editing) {
                  const hasAny = ["districts","project_types","unit_types","projects"].some(k => (int[k]||[]).length);
                  return (
                    <div style={{ gridColumn:"1/-1", background:"#f0fdf4", border:"1px solid #bbf7d0", borderRadius:8, padding:"8px 12px", marginTop:4 }}>
                      <div style={{ fontSize:10, fontWeight:700, color:"#166534", marginBottom:6 }}>🎯 الاهتمامات</div>
                      {hasAny ? (
                        <div style={{ display:"flex", flexWrap:"wrap", gap:4 }}>
                          {(int.districts||[]).map(d => <span key={d} style={{ background:"#dbeafe", color:"#1d4ed8", fontSize:9.5, padding:"2px 8px", borderRadius:10, fontWeight:600 }}>📍 {d}</span>)}
                          {(int.project_types||[]).map(d => <span key={d} style={{ background:"#fef3c7", color:"#92400e", fontSize:9.5, padding:"2px 8px", borderRadius:10, fontWeight:600 }}>🏗️ {d}</span>)}
                          {(int.unit_types||[]).map(d => <span key={d} style={{ background:"#ede9fe", color:"#7c3aed", fontSize:9.5, padding:"2px 8px", borderRadius:10, fontWeight:600 }}>🏠 {d}</span>)}
                          {(int.projects||[]).map(d => <span key={d} style={{ background:"#dcfce7", color:"#166534", fontSize:9.5, padding:"2px 8px", borderRadius:10, fontWeight:600 }}>📋 {d}</span>)}
                        </div>
                      ) : (
                        <div style={{ fontSize:10, color:"#94a3b8" }}>لا اهتمامات محددة — اضغط "تعديل" لإضافتها</div>
                      )}
                    </div>
                  );
                }
                return (
                  <div style={{ gridColumn:"1/-1", background:"#f0fdf4", border:"1px solid #bbf7d0", borderRadius:8, padding:"10px 12px", marginTop:4 }}>
                    <div style={{ fontSize:11, fontWeight:700, color:"#166534", marginBottom:8 }}>🎯 الاهتمامات</div>
                    <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10 }}>
                      {/* الأحياء */}
                      <div>
                        <div style={{ fontSize:10, fontWeight:700, color:"#1d4ed8", marginBottom:4 }}>📍 الأحياء</div>
                        <div style={{ maxHeight:100, overflowY:"auto" }}>
                          {(allOptions?.client_interests_districts||[]).map(o => cbx("districts", o.label))}
                          {!(allOptions?.client_interests_districts||[]).length && <div style={{ fontSize:10, color:"#94a3b8" }}>أضف أحياء من الإعدادات</div>}
                        </div>
                      </div>
                      {/* نوع المشاريع */}
                      <div>
                        <div style={{ fontSize:10, fontWeight:700, color:"#92400e", marginBottom:4 }}>🏗️ نوع المشاريع</div>
                        <div style={{ maxHeight:100, overflowY:"auto" }}>
                          {(allOptions?.client_interests_project_types||[]).map(o => cbx("project_types", o.label))}
                          {!(allOptions?.client_interests_project_types||[]).length && <div style={{ fontSize:10, color:"#94a3b8" }}>أضف من الإعدادات</div>}
                        </div>
                      </div>
                      {/* نوع الوحدات */}
                      <div>
                        <div style={{ fontSize:10, fontWeight:700, color:"#7c3aed", marginBottom:4 }}>🏠 نوع الوحدات</div>
                        <div style={{ maxHeight:100, overflowY:"auto" }}>
                          {(allOptions?.client_interests_unit_types||[]).map(o => cbx("unit_types", o.label))}
                          {!(allOptions?.client_interests_unit_types||[]).length && <div style={{ fontSize:10, color:"#94a3b8" }}>أضف من الإعدادات</div>}
                        </div>
                      </div>
                      {/* المشاريع */}
                      <div>
                        <div style={{ fontSize:10, fontWeight:700, color:"#166534", marginBottom:4 }}>📋 المشاريع</div>
                        <div style={{ maxHeight:100, overflowY:"auto" }}>
                          {projectsList.map(p => cbx("projects", p.name))}
                          {!projectsList.length && <div style={{ fontSize:10, color:"#94a3b8" }}>لا توجد مشاريع</div>}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })()}
              {entityType === "marketer" && <div>
                <label style={{ fontSize:10, color:"#64748b", fontWeight:600, display:"block", marginBottom:3 }}>شركة المسوق</label>
                <input value={editData.company} onChange={e => setEditData(d => ({...d, company:e.target.value}))}
                  style={{ width:"100%", padding:"7px 10px", border:"1px solid #e2e8f0", borderRadius:6, fontFamily:"inherit", fontSize:12, outline:"none", boxSizing:"border-box" }} />
              </div>}
              {entityType === "marketer" && <div>
                <label style={{ fontSize:10, color:"#64748b", fontWeight:600, display:"block", marginBottom:3 }}>رقم الهوية</label>
                <input value={editData.id_number} onChange={e => setEditData(d => ({...d, id_number:e.target.value}))}
                  style={{ width:"100%", padding:"7px 10px", border:"1px solid #e2e8f0", borderRadius:6, fontFamily:"inherit", fontSize:12, outline:"none", boxSizing:"border-box" }} />
              </div>}
              {entityType === "marketer" && <div>
                <label style={{ fontSize:10, color:"#64748b", fontWeight:600, display:"block", marginBottom:3 }}>الجنسية</label>
                <select value={editData.nationality} onChange={e => setEditData(d => ({...d, nationality:e.target.value}))}
                  style={{ width:"100%", padding:"7px 10px", border:"1px solid #e2e8f0", borderRadius:6, fontFamily:"inherit", fontSize:12, outline:"none", boxSizing:"border-box" }}>
                  <option value="">— اختر —</option>
                  {(allOptions?.marketer_nationality||[]).map(o => <option key={o.id} value={o.label}>{o.label}</option>)}
                </select>
              </div>}
              {entityType === "marketer" && <div>
                <label style={{ fontSize:10, color:"#64748b", fontWeight:600, display:"block", marginBottom:3 }}>تصنيف المسوق</label>
                <select value={editData.marketer_classification} onChange={e => setEditData(d => ({...d, marketer_classification:e.target.value}))}
                  style={{ width:"100%", padding:"7px 10px", border:"1px solid #e2e8f0", borderRadius:6, fontFamily:"inherit", fontSize:12, outline:"none", boxSizing:"border-box" }}>
                  <option value="">— اختر —</option>
                  {(allOptions?.marketer_classification||[]).map(o => <option key={o.id} value={o.label}>{o.label}</option>)}
                </select>
              </div>}
              {entityType === "marketer" && <div>
                <label style={{ fontSize:10, color:"#64748b", fontWeight:600, display:"block", marginBottom:3 }}>IBAN</label>
                <input value={editData.iban} onChange={e => setEditData(d => ({...d, iban:e.target.value}))} dir="ltr"
                  style={{ width:"100%", padding:"7px 10px", border:"1px solid #e2e8f0", borderRadius:6, fontFamily:"inherit", fontSize:12, outline:"none", boxSizing:"border-box" }} />
              </div>}
              {entityType === "marketer" && <div>
                <label style={{ fontSize:10, color:"#64748b", fontWeight:600, display:"block", marginBottom:3 }}>اسم البنك</label>
                <select value={editData.bank_name} onChange={e => setEditData(d => ({...d, bank_name:e.target.value}))}
                  style={{ width:"100%", padding:"7px 10px", border:"1px solid #e2e8f0", borderRadius:6, fontFamily:"inherit", fontSize:12, outline:"none", boxSizing:"border-box" }}>
                  <option value="">— اختر —</option>
                  {(allOptions?.bank_name||[]).map(o => <option key={o.id} value={o.label}>{o.label}</option>)}
                </select>
              </div>}
              {entityType === "marketer" && <div>
                <label style={{ fontSize:10, color:"#64748b", fontWeight:600, display:"block", marginBottom:3 }}>عدد الزيارات لمكتب الهيئة</label>
                <input type="number" min="0" value={editData.visit_count} onChange={e => setEditData(d => ({...d, visit_count: parseInt(e.target.value)||0}))}
                  style={{ width:"100%", padding:"7px 10px", border:"1px solid #e2e8f0", borderRadius:6, fontFamily:"inherit", fontSize:12, outline:"none", boxSizing:"border-box" }} />
              </div>}
              {entityType === "developer" && <div>
                <label style={{ fontSize:10, color:"#64748b", fontWeight:600, display:"block", marginBottom:3 }}>ممثل المطور</label>
                <input value={editData.representative_name} onChange={e => setEditData(d => ({...d, representative_name:e.target.value}))}
                  style={{ width:"100%", padding:"7px 10px", border:"1px solid #e2e8f0", borderRadius:6, fontFamily:"inherit", fontSize:12, outline:"none", boxSizing:"border-box" }} />
              </div>}
              {entityType === "developer" && <div>
                <label style={{ fontSize:10, color:"#64748b", fontWeight:600, display:"block", marginBottom:3 }}>رقم ممثل المطور</label>
                <input value={editData.representative_phone} onChange={e => setEditData(d => ({...d, representative_phone:e.target.value}))}
                  style={{ width:"100%", padding:"7px 10px", border:"1px solid #e2e8f0", borderRadius:6, fontFamily:"inherit", fontSize:12, outline:"none", boxSizing:"border-box" }} />
              </div>}
              {/* Company Project Toggle for Developers */}
              {entityType === "developer" && (
                <div style={{ gridColumn:"1/-1", background: editData.is_company_project ? "#fef3c7" : "#f8fafc", border: `1px solid ${editData.is_company_project ? "#fcd34d" : "#e2e8f0"}`, borderRadius:6, padding:10 }}>
                  <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom: editData.is_company_project ? 10 : 0 }}>
                    <label style={{ display:"flex", alignItems:"center", gap:8, cursor:"pointer" }}>
                      <input type="checkbox" checked={editData.is_company_project || false}
                        onChange={e => setEditData(d => ({...d, is_company_project: e.target.checked, linked_project_id: e.target.checked ? d.linked_project_id : null}))}
                        style={{ width:18, height:18, accentColor:"#f59e0b" }} />
                      <span style={{ fontSize:13, fontWeight:600, color:"#92400e" }}>🏢 هذا مشروع للشركة</span>
                    </label>
                    {editData.is_company_project && <span style={{ fontSize:10, color:"#b45309", background:"#fef3c7", padding:"2px 8px", borderRadius:10 }}>مرتبط بمشروع</span>}
                  </div>
                  {editData.is_company_project && (
                    <div>
                      <label style={{ fontSize:11, color:"#92400e", fontWeight:600, display:"block", marginBottom:4 }}>المشروع المرتبط</label>
                      <select value={editData.linked_project_id || ""} onChange={e => setEditData(d => ({...d, linked_project_id: e.target.value ? parseInt(e.target.value) : null}))}
                        style={{ width:"100%", padding:"8px 12px", border:"1px solid #fcd34d", borderRadius:7, fontFamily:"inherit", fontSize:13, outline:"none", boxSizing:"border-box", background:"#fff" }}>
                        <option value="">— اختر المشروع —</option>
                        {(projectsList || []).map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
                      </select>
                      <p style={{ fontSize:10, color:"#b45309", marginTop:6, marginBottom:0 }}>💡 المستخدمون بنطاق "مشاريع الشركة" سيرون فقط الحجوزات المرتبطة بهذا المطور</p>
                    </div>
                  )}
                </div>
              )}
              {entityType === "marketer" && <div style={{ gridColumn:"1/-1" }}>
                <label style={{ fontSize:11, color:"#64748b", fontWeight:600, display:"block", marginBottom:4 }}>🏷 اهتمامات المسوق (Tags)</label>
                <InterestsTags interests={editData.interests} onChange={v => setEditData(d => ({...d, interests:v}))} />
              </div>}
              {/* ── المجموعات (مسوقين / عملاء) ── */}
              {/* v3.3.745 — في العرض: المجموعات المنضم إليها فقط؛ القائمة الكاملة عند التعديل */}
              {entityType !== "developer" && !editing && (
                <div style={{ gridColumn:"1/-1", background:"#f8fafc", border:"1px solid #e2e8f0", borderRadius:8, padding:"8px 12px" }}>
                  <div style={{ fontSize:10, color:"#64748b", fontWeight:700, marginBottom:6 }}>
                    👥 {entityType === "marketer" ? "مجموعات المسوقين" : "مجموعات العملاء"}
                  </div>
                  {loadingGroups ? (
                    <div style={{ fontSize:10, color:"#94a3b8" }}>جاري التحميل...</div>
                  ) : (() => {
                    const memberGroups = allGroups.filter(g => memberGroupIds.has(g.id));
                    return memberGroups.length === 0 ? (
                      <div style={{ fontSize:10, color:"#94a3b8" }}>غير منضم لأي مجموعة — اضغط "تعديل" للإضافة</div>
                    ) : (
                      <div style={{ display:"flex", flexWrap:"wrap", gap:5 }}>
                        {memberGroups.map(g => (
                          <span key={g.id} style={{ background:"#f0fdf4", color:"#166534", border:"1px solid #86efac",
                            borderRadius:12, padding:"2px 10px", fontSize:10, fontWeight:600 }}>
                            {g.name}{g.member_count != null ? ` (${g.member_count})` : ""}
                          </span>
                        ))}
                      </div>
                    );
                  })()}
                </div>
              )}
              {entityType !== "developer" && editing && (
                <div style={{ gridColumn:"1/-1", background:"#f8fafc", border:"1px solid #e2e8f0", borderRadius:8, padding:12 }}>
                  <label style={{ fontSize:11, color:"#64748b", fontWeight:600, display:"block", marginBottom:8 }}>
                    👥 {entityType === "marketer" ? "مجموعات المسوقين" : "مجموعات العملاء"}
                  </label>
                  {loadingGroups ? (
                    <div style={{ fontSize:12, color:"#94a3b8", padding:8 }}>جاري التحميل...</div>
                  ) : allGroups.length === 0 ? (
                    <div style={{ fontSize:12, color:"#94a3b8", padding:8 }}>لا توجد مجموعات — أنشئ مجموعة من صفحة المجموعات أولاً</div>
                  ) : (
                    <div style={{ display:"flex", flexDirection:"column", gap:6, maxHeight:180, overflowY:"auto" }}>
                      {allGroups.map(g => {
                        const isMember = memberGroupIds.has(g.id);
                        const isToggling = togglingGroup === g.id;
                        return (
                          <label key={g.id} style={{
                            display:"flex", alignItems:"center", gap:10, padding:"7px 10px",
                            background: isMember ? "#f0fdf4" : "#fff",
                            border: `1px solid ${isMember ? "#86efac" : "#e2e8f0"}`,
                            borderRadius:7, cursor: isToggling ? "wait" : "pointer",
                            opacity: isToggling ? 0.6 : 1, transition:"all 0.15s"
                          }}>
                            <input type="checkbox" checked={isMember} disabled={isToggling}
                              onChange={() => toggleGroup(g.id, isMember)}
                              style={{ width:16, height:16, accentColor:"#22c55e", cursor: isToggling ? "wait" : "pointer" }} />
                            <span style={{ fontSize:13, fontWeight:isMember ? 600 : 400, color: isMember ? "#166534" : "#374151", flex:1 }}>
                              {g.name}
                            </span>
                            {g.member_count != null && (
                              <span style={{ fontSize:10, color:"#94a3b8", background:"#f1f5f9", padding:"2px 8px", borderRadius:10 }}>
                                {g.member_count} عضو
                              </span>
                            )}
                          </label>
                        );
                      })}
                    </div>
                  )}
                </div>
              )}
              <div style={{ gridColumn:"1/-1" }}>
                <label style={{ fontSize:11, color:"#64748b", fontWeight:600, display:"block", marginBottom:4 }}>ملاحظات</label>
                <textarea value={editData.notes} onChange={e => setEditData(d => ({...d, notes:e.target.value}))} rows={2}
                  style={{ width:"100%", padding:"8px 12px", border:"1px solid #e2e8f0", borderRadius:7, fontFamily:"inherit", fontSize:13, outline:"none", resize:"vertical", boxSizing:"border-box" }} />
              </div>
              {/* v3.3.745 — أزرار الحفظ/الإلغاء انتقلت لرأس اللوحة */}
            </div>
          </fieldset>

          {/* v3.3.743 — إحصائيات المسوق المحسوبة (عرض فقط) */}
          {!editing && entityType === "marketer" && canViewReservations && !loading && (() => {
            const soldRes = reservations.filter(r => r.operation_status === "تمت العمليه");
            const projectNames = [...new Set(soldRes.map(r => r.project_name).filter(Boolean))];
            return (
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:8, marginTop:10 }}>
                <div style={{ background:"#eff6ff", border:"1px solid #bfdbfe", borderRadius:6, padding:"6px 10px" }}>
                  <div style={{ fontSize:9, color:"#3b82f6", fontWeight:600, marginBottom:2 }}>📊 عدد الحجوزات</div>
                  <div style={{ fontSize:13, color:"#1d4ed8", fontWeight:700 }}>{reservations.length}</div>
                </div>
                <div style={{ background:"#f0fdf4", border:"1px solid #bbf7d0", borderRadius:6, padding:"6px 10px" }}>
                  <div style={{ fontSize:9, color:"#16a34a", fontWeight:600, marginBottom:2 }}>✅ عدد البيعات (تمت)</div>
                  <div style={{ fontSize:13, color:"#166534", fontWeight:700 }}>{soldRes.length}</div>
                </div>
                {projectNames.length > 0 && (
                  <div style={{ background:"#faf5ff", border:"1px solid #e9d5ff", borderRadius:6, padding:"6px 10px", gridColumn:"1/-1" }}>
                    <div style={{ fontSize:9, color:"#7c3aed", fontWeight:600, marginBottom:4 }}>🏢 المشاريع اللي تمت فيها بيعات</div>
                    <div style={{ display:"flex", gap:4, flexWrap:"wrap" }}>
                      {projectNames.map((p,i) => <span key={i} style={{ background:"#e9d5ff", color:"#6d28d9", borderRadius:8, padding:"2px 8px", fontSize:10, fontWeight:600 }}>{p}</span>)}
                    </div>
                  </div>
                )}
              </div>
            );
          })()}
          {false && (
            <div>
              <div style={{ fontSize:10, fontWeight:700, color:"#64748b", marginBottom:10, display:"flex", alignItems:"center", gap:6 }}>
                📋 البيانات الأساسية
              </div>
              <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(130px, 1fr))", gap:10 }}>
                {/* الهاتف */}
                {hasPhone && (
                  <div style={{ background:"#fff", border:"1px solid #e2e8f0", borderRadius:6, padding:"6px 10px" }}>
                    <div style={{ fontSize:9, color:"#94a3b8", fontWeight:600, marginBottom:2 }}>📞 الهاتف</div>
                    <div style={{ fontSize:11, color: entity.phone ? "#1e293b" : "#cbd5e1", fontWeight:500 }}>{entity.phone || "—"}</div>
                  </div>
                )}
                {/* Client fields */}
                {entityType === "client" && (
                  <>
                    <div style={{ gridColumn:"1/-1", background: entity.is_company_client ? "#dcfce7" : "#f1f5f9", border:"1px solid #e2e8f0", borderRadius:6, padding:"6px 12px", display:"flex", alignItems:"center", gap:6 }}>
                      <span style={{ fontSize:12, fontWeight:700, color: entity.is_company_client ? "#166534" : "#94a3b8" }}>
                        {entity.is_company_client ? "🏢 عميل الشركة ✅" : "🏢 ليس عميل شركة"}
                      </span>
                    </div>
                    <div style={{ background:"#fff", border:"1px solid #e2e8f0", borderRadius:6, padding:"6px 10px" }}>
                      <div style={{ fontSize:9, color:"#94a3b8", fontWeight:600, marginBottom:2 }}>🪪 رقم هوية العميل</div>
                      <div style={{ fontSize:11, color: entity.client_number ? "#1e293b" : "#cbd5e1", fontWeight:500 }}>{entity.client_number || "—"}</div>
                    </div>
                    <div style={{ background:"#fff", border:"1px solid #e2e8f0", borderRadius:6, padding:"6px 10px" }}>
                      <div style={{ fontSize:9, color:"#94a3b8", fontWeight:600, marginBottom:2 }}>🏦 IBAN</div>
                      <div style={{ fontSize:11, color: entity.iban ? "#1e293b" : "#cbd5e1", fontWeight:500, direction:"ltr", textAlign:"right" }}>{entity.iban || "—"}</div>
                    </div>
                    <div style={{ background:"#fff", border:"1px solid #e2e8f0", borderRadius:6, padding:"6px 10px" }}>
                      <div style={{ fontSize:9, color:"#94a3b8", fontWeight:600, marginBottom:2 }}>📋 مصدر العميل</div>
                      <div style={{ fontSize:11, color: entity.client_type ? "#1e293b" : "#cbd5e1", fontWeight:500 }}>{entity.client_type || "—"}</div>
                    </div>
                    <div style={{ background:"#fff", border:"1px solid #e2e8f0", borderRadius:6, padding:"6px 10px" }}>
                      <div style={{ fontSize:9, color:"#94a3b8", fontWeight:600, marginBottom:2 }}>👤 نوع العميل</div>
                      <div style={{ fontSize:11 }}>{entity.client_category ? <span style={{ background:"#fef3c7", color:"#92400e", borderRadius:6, padding:"2px 6px", fontSize:9, fontWeight:600 }}>{entity.client_category}</span> : <span style={{ color:"#cbd5e1" }}>—</span>}</div>
                    </div>
                    <div style={{ background:"#fff", border:"1px solid #e2e8f0", borderRadius:6, padding:"6px 10px" }}>
                      <div style={{ fontSize:9, color:"#94a3b8", fontWeight:600, marginBottom:2 }}>🏷 تصنيف العميل</div>
                      <div style={{ fontSize:11 }}>{entity.client_stage ? <span style={{ background:"#e0e7ff", color:"#3730a3", borderRadius:6, padding:"2px 6px", fontSize:9, fontWeight:600 }}>{entity.client_stage}</span> : <span style={{ color:"#cbd5e1" }}>—</span>}</div>
                    </div>
                    <div style={{ background:"#fff", border:"1px solid #e2e8f0", borderRadius:6, padding:"6px 10px" }}>
                      <div style={{ fontSize:9, color:"#94a3b8", fontWeight:600, marginBottom:2 }}>🏠 عدد الزيارات</div>
                      <div style={{ fontSize:11, color:"#1e293b", fontWeight:500 }}>{entity.visit_count || 0}</div>
                    </div>
                  </>
                )}
                {/* اهتمامات العميل */}
                {entityType === "client" && (() => {
                  const int = entity.interests ? (typeof entity.interests === "string" ? JSON.parse(entity.interests) : entity.interests) : {};
                  const hasAny = Object.values(int).some(v => Array.isArray(v) ? v.length > 0 : !!v);
                  if (!hasAny) return null;
                  return (
                    <div style={{ gridColumn:"1/-1", background:"#f0fdf4", border:"1px solid #bbf7d0", borderRadius:8, padding:"8px 12px" }}>
                      <div style={{ fontSize:10, fontWeight:700, color:"#166534", marginBottom:6 }}>🎯 الاهتمامات</div>
                      <div style={{ display:"flex", flexWrap:"wrap", gap:4 }}>
                        {(int.districts||[]).map(d => <span key={d} style={{ background:"#dbeafe", color:"#1d4ed8", fontSize:9, padding:"2px 6px", borderRadius:10, fontWeight:600 }}>📍{d}</span>)}
                        {(int.project_types||[]).map(d => <span key={d} style={{ background:"#fef3c7", color:"#92400e", fontSize:9, padding:"2px 6px", borderRadius:10, fontWeight:600 }}>🏗️{d}</span>)}
                        {(int.unit_types||[]).map(d => <span key={d} style={{ background:"#ede9fe", color:"#7c3aed", fontSize:9, padding:"2px 6px", borderRadius:10, fontWeight:600 }}>🏠{d}</span>)}
                        {(int.projects||[]).map(d => <span key={d} style={{ background:"#dcfce7", color:"#166534", fontSize:9, padding:"2px 6px", borderRadius:10, fontWeight:600 }}>📋{d}</span>)}
                      </div>
                    </div>
                  );
                })()}
                {/* Developer fields */}
                {entityType === "developer" && (
                  <>
                    <div style={{ background:"#fff", border:"1px solid #e2e8f0", borderRadius:6, padding:"6px 10px" }}>
                      <div style={{ fontSize:9, color:"#94a3b8", fontWeight:600, marginBottom:2 }}>👤 ممثل المطور</div>
                      <div style={{ fontSize:11, color: entity.representative_name ? "#1e293b" : "#cbd5e1", fontWeight:500 }}>{entity.representative_name || "—"}</div>
                    </div>
                    <div style={{ background:"#fff", border:"1px solid #e2e8f0", borderRadius:6, padding:"6px 10px" }}>
                      <div style={{ fontSize:9, color:"#94a3b8", fontWeight:600, marginBottom:2 }}>📱 رقم الممثل</div>
                      <div style={{ fontSize:11, color: entity.representative_phone ? "#1e293b" : "#cbd5e1", fontWeight:500 }}>{entity.representative_phone || "—"}</div>
                    </div>
                  </>
                )}
                {/* Marketer fields */}
                {entityType === "marketer" && (
                  <>
                    <div style={{ background:"#fff", border:"1px solid #e2e8f0", borderRadius:6, padding:"6px 10px" }}>
                      <div style={{ fontSize:9, color:"#94a3b8", fontWeight:600, marginBottom:2 }}>🏢 شركة المسوق</div>
                      <div style={{ fontSize:11, color: entity.office ? "#1e293b" : "#cbd5e1", fontWeight:500 }}>{entity.office || "—"}</div>
                    </div>
                    <div style={{ background:"#fff", border:"1px solid #e2e8f0", borderRadius:6, padding:"6px 10px" }}>
                      <div style={{ fontSize:9, color:"#94a3b8", fontWeight:600, marginBottom:2 }}>🪪 رقم الهوية</div>
                      <div style={{ fontSize:11, color: entity.id_number ? "#1e293b" : "#cbd5e1", fontWeight:500 }}>{entity.id_number || "—"}</div>
                    </div>
                    <div style={{ background:"#fff", border:"1px solid #e2e8f0", borderRadius:6, padding:"6px 10px" }}>
                      <div style={{ fontSize:9, color:"#94a3b8", fontWeight:600, marginBottom:2 }}>🌍 الجنسية</div>
                      <div style={{ fontSize:11, color: entity.nationality ? "#1e293b" : "#cbd5e1", fontWeight:500 }}>{entity.nationality || "—"}</div>
                    </div>
                    <div style={{ background:"#fff", border:"1px solid #e2e8f0", borderRadius:6, padding:"6px 10px" }}>
                      <div style={{ fontSize:9, color:"#94a3b8", fontWeight:600, marginBottom:2 }}>📋 تصنيف المسوق</div>
                      <div style={{ fontSize:11, color: entity.marketer_classification ? "#1e293b" : "#cbd5e1", fontWeight:500 }}>{entity.marketer_classification || "—"}</div>
                    </div>
                    <div style={{ background:"#fff", border:"1px solid #e2e8f0", borderRadius:6, padding:"6px 10px" }}>
                      <div style={{ fontSize:9, color:"#94a3b8", fontWeight:600, marginBottom:2 }}>🏦 البنك / IBAN</div>
                      <div style={{ fontSize:11, color: entity.bank_name || entity.iban ? "#1e293b" : "#cbd5e1", fontWeight:500 }}>{entity.bank_name ? entity.bank_name + " — " : ""}{entity.iban || "—"}</div>
                    </div>
                    <div style={{ background:"#fff", border:"1px solid #e2e8f0", borderRadius:6, padding:"6px 10px" }}>
                      <div style={{ fontSize:9, color:"#94a3b8", fontWeight:600, marginBottom:2 }}>🏛 زيارات مكتب الهيئة</div>
                      <div style={{ fontSize:11, color:"#1e293b", fontWeight:500 }}>{entity.visit_count || 0}</div>
                    </div>
                    {/* Computed: عدد الحجوزات, البيعات, المشاريع */}
                    {canViewReservations && !loading && (() => {
                      const soldRes = reservations.filter(r => r.operation_status === "تمت العمليه");
                      const projectNames = [...new Set(soldRes.map(r => r.project_name).filter(Boolean))];
                      return <>
                        <div style={{ background:"#eff6ff", border:"1px solid #bfdbfe", borderRadius:6, padding:"6px 10px" }}>
                          <div style={{ fontSize:9, color:"#3b82f6", fontWeight:600, marginBottom:2 }}>📊 عدد الحجوزات</div>
                          <div style={{ fontSize:13, color:"#1d4ed8", fontWeight:700 }}>{reservations.length}</div>
                        </div>
                        <div style={{ background:"#f0fdf4", border:"1px solid #bbf7d0", borderRadius:6, padding:"6px 10px" }}>
                          <div style={{ fontSize:9, color:"#16a34a", fontWeight:600, marginBottom:2 }}>✅ عدد البيعات (تمت)</div>
                          <div style={{ fontSize:13, color:"#166534", fontWeight:700 }}>{soldRes.length}</div>
                        </div>
                        {projectNames.length > 0 && (
                          <div style={{ background:"#faf5ff", border:"1px solid #e9d5ff", borderRadius:6, padding:"6px 10px", gridColumn:"1/-1" }}>
                            <div style={{ fontSize:9, color:"#7c3aed", fontWeight:600, marginBottom:4 }}>🏢 المشاريع اللي تمت فيها بيعات</div>
                            <div style={{ display:"flex", gap:4, flexWrap:"wrap" }}>
                              {projectNames.map((p,i) => <span key={i} style={{ background:"#e9d5ff", color:"#6d28d9", borderRadius:8, padding:"2px 8px", fontSize:10, fontWeight:600 }}>{p}</span>)}
                            </div>
                          </div>
                        )}
                      </>;
                    })()}
                    {entity.interests && (() => {
                      try {
                        const tags = typeof entity.interests === "string" ? JSON.parse(entity.interests) : entity.interests;
                        if (tags?.length) return (
                          <div style={{ background:"#fff", border:"1px solid #e2e8f0", borderRadius:6, padding:"6px 10px", gridColumn:"1/-1" }}>
                            <div style={{ fontSize:9, color:"#94a3b8", fontWeight:600, marginBottom:2 }}>🏷 الاهتمامات</div>
                            <div style={{ display:"flex", gap:3, flexWrap:"wrap" }}>
                              {tags.slice(0,5).map((t,i) => <span key={i} style={{ background:"#e0e7ff", color:"#3730a3", borderRadius:6, padding:"1px 5px", fontSize:8, fontWeight:600 }}>{t}</span>)}
                              {tags.length > 5 && <span style={{ fontSize:8, color:"#94a3b8" }}>+{tags.length-5}</span>}
                            </div>
                          </div>
                        );
                      } catch(e) {}
                      return null;
                    })()}
                  </>
                )}
                {/* Notes */}
                <div style={{ background:"#fff", border:"1px solid #e2e8f0", borderRadius:6, padding:"6px 10px", gridColumn: entity.notes?.length > 30 ? "1/-1" : undefined }}>
                  <div style={{ fontSize:9, color:"#94a3b8", fontWeight:600, marginBottom:2 }}>📝 ملاحظات</div>
                  <div style={{ fontSize:11, color: entity.notes ? "#64748b" : "#cbd5e1", fontWeight:400 }}>{entity.notes || "—"}</div>
                </div>
                {/* ── المجموعات (view mode) ── */}
                {entityType !== "developer" && (
                  <div style={{ gridColumn:"1/-1", background:"#f8fafc", border:"1px solid #e2e8f0", borderRadius:8, padding:"8px 12px" }}>
                    <div style={{ fontSize:10, fontWeight:700, color:"#64748b", marginBottom:6, display:"flex", alignItems:"center", gap:4 }}>
                      👥 {entityType === "marketer" ? "مجموعات المسوقين" : "مجموعات العملاء"}
                    </div>
                    {loadingGroups ? (
                      <div style={{ fontSize:11, color:"#94a3b8" }}>جاري التحميل...</div>
                    ) : allGroups.length === 0 ? (
                      <div style={{ fontSize:11, color:"#94a3b8" }}>لا توجد مجموعات</div>
                    ) : (
                      <div style={{ display:"flex", flexDirection:"column", gap:5, maxHeight:160, overflowY:"auto" }}>
                        {allGroups.map(g => {
                          const isMember = memberGroupIds.has(g.id);
                          const isToggling = togglingGroup === g.id;
                          return (
                            <label key={g.id} style={{
                              display:"flex", alignItems:"center", gap:8, padding:"6px 10px",
                              background: isMember ? "#f0fdf4" : "#fff",
                              border: `1px solid ${isMember ? "#86efac" : "#e2e8f0"}`,
                              borderRadius:6, cursor: isToggling ? "wait" : "pointer",
                              opacity: isToggling ? 0.6 : 1, transition:"all 0.15s"
                            }}>
                              <input type="checkbox" checked={isMember} disabled={isToggling}
                                onChange={() => toggleGroup(g.id, isMember)}
                                style={{ width:15, height:15, accentColor:"#22c55e", cursor: isToggling ? "wait" : "pointer" }} />
                              <span style={{ fontSize:12, fontWeight: isMember ? 600 : 400, color: isMember ? "#166534" : "#374151", flex:1 }}>
                                {g.name}
                              </span>
                              {g.member_count != null && (
                                <span style={{ fontSize:9, color:"#94a3b8", background:"#f1f5f9", padding:"1px 6px", borderRadius:8 }}>
                                  {g.member_count} عضو
                                </span>
                              )}
                            </label>
                          );
                        })}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        {/* ── Stats ── */}
        {canViewReservations && !loading && (
          <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", borderBottom:"1px solid #e2e8f0", marginTop:8 }}>
            {[
              { label:"إجمالي الحجوزات", value:reservations.length, color:"#2563eb", bg:"#eff6ff" },
              { label:"مكتملة", value:completed, color:"#16a34a", bg:"#f0fdf4" },
              { label:"إجمالي القيمة", value:fmt(totalValue)+" ر.س", color:"#7c3aed", bg:"#faf5ff" },
              { label:"إجمالي الدلالة", value:fmt(totalDalala)+" ر.س", color:"#d97706", bg:"#fffbeb" },
            ].map((s,i) => (
              <div key={i} style={{ padding:"12px 16px", textAlign:"center", background:s.bg, borderLeft: i<3 ? "1px solid #e2e8f0" : "none" }}>
                <div style={{ fontSize:17, fontWeight:800, color:s.color }}>{s.value}</div>
                <div style={{ fontSize:10, color:"#64748b", marginTop:2, fontWeight:500 }}>{s.label}</div>
              </div>
            ))}
          </div>
        )}

        {/* ── Tabs: حجوزات | وحدات ── */}
        {canViewReservations && entityType === "client" && (
          <div style={{ display:"flex", borderBottom:"2px solid #e2e8f0", background:"#fff" }}>
            <button onClick={() => setActiveTab("reservations")}
              style={{ flex:1, padding:"10px", border:"none", background:"none", cursor:"pointer", fontFamily:"inherit", fontSize:13, fontWeight: activeTab==="reservations" ? 700 : 500,
                color: activeTab==="reservations" ? "#166534" : "#64748b", borderBottom: activeTab==="reservations" ? "3px solid #166534" : "3px solid transparent" }}>
              🗂️ الحجوزات ({reservations.length})
            </button>
            <button onClick={() => setActiveTab("units")}
              style={{ flex:1, padding:"10px", border:"none", background:"none", cursor:"pointer", fontFamily:"inherit", fontSize:13, fontWeight: activeTab==="units" ? 700 : 500,
                color: activeTab==="units" ? "#1d4ed8" : "#64748b", borderBottom: activeTab==="units" ? "3px solid #1d4ed8" : "3px solid transparent" }}>
              🏠 الوحدات المملوكة ({clientUnits.length})
            </button>
          </div>
        )}

        {/* ── Tab: Reservations ── */}
        {canViewReservations && (activeTab === "reservations" || entityType !== "client") ? (
        <div style={{}}>
          {entityType !== "client" && (
            <div style={{ padding:"12px 24px", borderBottom:"1px solid #f1f5f9", background:"#fff", position:"sticky", top:0, zIndex:1 }}>
              <span style={{ fontSize:13, fontWeight:700, color:"#1e293b" }}>🗂️ الحجوزات المرتبطة</span>
              {!loading && <span style={{ fontSize:11, color:"#94a3b8", marginRight:8 }}>({reservations.length})</span>}
            </div>
          )}

          {loading ? (
            <div style={{ padding:48, textAlign:"center" }}>
              <div style={{ fontSize:32, marginBottom:12 }}>⏳</div>
              <div style={{ color:"#94a3b8", fontSize:13 }}>جاري التحميل...</div>
            </div>
          ) : reservations.length === 0 ? (
            <div style={{ padding:48, textAlign:"center" }}>
              <div style={{ fontSize:40, marginBottom:12 }}>📭</div>
              <div style={{ color:"#94a3b8", fontSize:14 }}>لا توجد حجوزات مرتبطة</div>
            </div>
          ) : (
            <table style={{ width:"100%", borderCollapse:"collapse", fontSize:13 }}>
              <thead>
                <tr style={{ background:"#f8fafc" }}>
                  {["م","التاريخ","نوع العملية","العميل","المطور","القيمة","الدلالة","الحالة"].map(h => (
                    <th key={h} style={{ padding:"9px 12px", textAlign:"right", fontWeight:600, color:"#64748b", fontSize:11, borderBottom:"2px solid #e2e8f0", whiteSpace:"nowrap" }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {reservations.map((r) => {
                  const sc = statusColor(r.operation_status);
                  return (
                    <tr key={r.id}
                      style={{ borderBottom:"1px solid #f1f5f9", cursor:"pointer", transition:"background 0.1s" }}
                      onMouseEnter={e => e.currentTarget.style.background="#f8fafc"}
                      onMouseLeave={e => e.currentTarget.style.background="transparent"}>
                      <td style={{ padding:"9px 12px", whiteSpace:"nowrap" }}>
                        <span 
                          onClick={() => window.open(`/?reservation=${r.id}`, '_blank')}
                          style={{ 
                            color:"#2563eb", 
                            fontWeight:700, 
                            cursor:"pointer",
                            background:"#eff6ff",
                            padding:"3px 8px",
                            borderRadius:6,
                            border:"1px solid #bfdbfe",
                            display:"inline-flex",
                            alignItems:"center",
                            gap:4
                          }}
                          title="اضغط لفتح الحجز">
                          #{r.id} <span style={{ fontSize:10, opacity:0.7 }}>↗</span>
                        </span>
                      </td>
                      <td style={{ padding:"9px 12px", color:"#64748b", whiteSpace:"nowrap" }} onClick={() => setSelectedRes(r)}>{r.date?.slice(0,10)}</td>
                      <td style={{ padding:"9px 12px" }} onClick={() => setSelectedRes(r)}>
                        <span style={{ background: r.operation_type?.includes("خارجي")?"#dbeafe":"#f0fdf4", color: r.operation_type?.includes("خارجي")?"#2563eb":"#166534", padding:"2px 8px", borderRadius:12, fontSize:11, whiteSpace:"nowrap" }}>
                          {r.operation_type}
                        </span>
                      </td>
                      <td style={{ padding:"9px 12px", fontWeight:600, maxWidth:130, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }} onClick={() => setSelectedRes(r)}>
                        {r.linked_clients?.map(c=>c.name).join("، ") || r.client_name}
                      </td>
                      <td style={{ padding:"9px 12px", color:"#64748b", maxWidth:110, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }} onClick={() => setSelectedRes(r)}>
                        {r.linked_developers?.map(d=>d.name).join("، ") || r.developer}
                      </td>
                      <td style={{ padding:"9px 12px", fontWeight:700, color:"#7c3aed", direction:"ltr", textAlign:"left", whiteSpace:"nowrap" }} onClick={() => setSelectedRes(r)}>{fmt(r.value)}</td>
                      <td style={{ padding:"9px 12px", fontWeight:600, color:"#d97706", direction:"ltr", textAlign:"left", whiteSpace:"nowrap" }} onClick={() => setSelectedRes(r)}>{fmt(r.dalala_amount)}</td>
                      <td style={{ padding:"9px 12px" }} onClick={() => setSelectedRes(r)}>
                        <span style={{ background:sc.bg, color:sc.text, padding:"3px 10px", borderRadius:12, fontSize:11, whiteSpace:"nowrap", fontWeight:600 }}>
                          {r.operation_status}
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                <tr style={{ background:"#f8fafc", fontWeight:700, borderTop:"2px solid #e2e8f0" }}>
                  <td colSpan={5} style={{ padding:"10px 12px", color:"#64748b", fontSize:12 }}>الإجمالي ({reservations.length} حجز)</td>
                  <td style={{ padding:"10px 12px", color:"#7c3aed", direction:"ltr", textAlign:"left" }}>{fmt(totalValue)}</td>
                  <td style={{ padding:"10px 12px", color:"#d97706", direction:"ltr", textAlign:"left" }}>{fmt(totalDalala)}</td>
                  <td></td>
                </tr>
              </tfoot>
            </table>
          )}
        </div>
        ) : activeTab === "units" && entityType === "client" ? (
        <div style={{ padding:16 }}>
          {clientUnits.length === 0 ? (
            <div style={{ padding:48, textAlign:"center" }}>
              <div style={{ fontSize:40, marginBottom:12 }}>🏠</div>
              <div style={{ color:"#94a3b8", fontSize:13 }}>لا توجد وحدات مملوكة</div>
            </div>
          ) : (
            <div style={{ display:"grid", gap:10 }}>
              {clientUnits.map((u, i) => {
                const stMap = { available:{l:"متاح",bg:"#dcfce7",c:"#166534"}, held:{l:"محجوز مؤقت",bg:"#fef9c3",c:"#854d0e"}, reserved:{l:"محجوز",bg:"#dbeafe",c:"#1e40af"}, sold:{l:"مُباع",bg:"#fee2e2",c:"#991b1b"} };
                const st = stMap[u.status] || stMap.available;
                return (
                  <div key={i} style={{ background:"#fff", border:"1px solid #e2e8f0", borderRadius:10, padding:14, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                    <div>
                      <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:4 }}>
                        <span style={{ fontSize:15, fontWeight:800, color:"#1e293b" }}>{u.unit_label || u.unit_number}</span>
                        <span style={{ background:st.bg, color:st.c, padding:"2px 8px", borderRadius:12, fontSize:10, fontWeight:700 }}>{st.l}</span>
                      </div>
                      <div style={{ fontSize:12, color:"#64748b" }}>
                        {u.project_name} — {u.building_name || ""} — الدور {u.floor_number}
                      </div>
                      <div style={{ fontSize:11, color:"#94a3b8", marginTop:2 }}>
                        {u.area_sqm ? `${u.area_sqm} م²` : ""} {u.price ? ` | ${fmt(u.price)} ر.س` : ""}
                      </div>
                    </div>
                    <div style={{ textAlign:"left" }}>
                      <div style={{ fontSize:11, color:"#64748b" }}>حجز #{u.reservation_id || u.id}</div>
                      <div style={{ fontSize:10, color:"#94a3b8" }}>{u.reservation_date?.slice(0,10)}</div>
                      {u.value > 0 && <div style={{ fontSize:12, fontWeight:700, color:"#166534", marginTop:2 }}>{fmt(u.value)} ر.س</div>}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
        ) : null}
        {/* v3.3.752 — بلا صلاحية عرض الحجوزات: القسم يختفي تمامًا (كانت تظهر رسالة قفل 🔒) */}
      </div>

      {/* Mini reservation viewer */}
      {canViewReservations && selectedRes && (
        <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.5)", zIndex:10000, display:"flex", alignItems:"center", justifyContent:"center" }}
          onClick={() => setSelectedRes(null)}>
          <div style={{ background:"#fff", borderRadius:12, width:600, maxWidth:"90vw", maxHeight:"80vh", overflowY:"auto", direction:"rtl", boxShadow:"0 20px 60px rgba(0,0,0,0.3)" }}
            onClick={e => e.stopPropagation()}>
            <div style={{ padding:"16px 20px", background:"linear-gradient(135deg,#1e293b,#334155)", borderRadius:"12px 12px 0 0", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
              <div 
                onClick={() => window.open(`/?reservation=${selectedRes.id}`, '_blank')}
                style={{ color:"#fff", fontWeight:800, fontSize:16, cursor:"pointer", display:"flex", alignItems:"center", gap:8 }}
                title="اضغط لفتح الحجز">
                <span style={{ background:"rgba(255,255,255,0.2)", padding:"4px 10px", borderRadius:6, border:"1px solid rgba(255,255,255,0.3)" }}>
                  حجز #{selectedRes.id}
                </span>
                <span style={{ fontSize:12, opacity:0.8 }}>↗</span>
              </div>
              <button onClick={() => setSelectedRes(null)} style={{ background:"rgba(255,255,255,0.15)", border:"none", color:"#fff", borderRadius:8, width:30, height:30, cursor:"pointer", fontSize:16 }}>✕</button>
            </div>
            <div style={{ padding:20, display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:"12px 20px" }}>
              {[
                ["التاريخ", selectedRes.date?.slice(0,10)],
                ["نوع العملية", selectedRes.operation_type],
                ["حالة العملية", selectedRes.operation_status],
                ["العميل", selectedRes.linked_clients?.map(c=>c.name).join("، ") || selectedRes.client_name],
                ["مصدر العميل", selectedRes.client_type],
                ["المطور", selectedRes.linked_developers?.map(d=>d.name).join("، ") || selectedRes.developer],
                ["نوع الوحدة", selectedRes.unit_type],
                ["الجاهزية", selectedRes.readiness],
                ["المسوق", selectedRes.linked_marketers?.map(m=>m.name).join("، ") || selectedRes.marketer],
                ["القيمة", selectedRes.value ? Number(selectedRes.value).toLocaleString("en-US") + " ر.س" : "—"],
                ["العربون", selectedRes.deposit_amount ? Number(selectedRes.deposit_amount).toLocaleString("en-US") + " ر.س" : "—"],
                ["الدلالة", selectedRes.dalala_amount ? Number(selectedRes.dalala_amount).toLocaleString("en-US") + " ر.س" : "—"],
                ["حالة العربون", selectedRes.deposit_status],
                ["الحساب", selectedRes.bank_account],
                ["حالة الدلالة", selectedRes.commission_status_res],
              ].map(([label, value]) => (
                <div key={label}>
                  <div style={{ fontSize:10, color:"#94a3b8", fontWeight:600, marginBottom:3 }}>{label}</div>
                  <div style={{ fontSize:13, color: value ? "#1e293b" : "#cbd5e1", fontWeight:500 }}>{value || "—"}</div>
                </div>
              ))}
              {selectedRes.notes && (
                <div style={{ gridColumn:"1/-1" }}>
                  <div style={{ fontSize:10, color:"#94a3b8", fontWeight:600, marginBottom:3 }}>ملاحظات</div>
                  <div style={{ fontSize:13, color:"#64748b" }}>{selectedRes.notes}</div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
